{
  "type": "Feature",
  "properties": {},
  "geometry": {
    "type": "Polygon",
    "coordinates": [
      [
        [180, 90],
        [-180, 90],
        [-180, -90],
        [180, -90],
        [180, 90]
      ],
      [
        [8.47276052, 50.099822435],
        [8.472763955, 50.099820846],
        [8.473125844, 50.099653364],
        [8.473410063, 50.099521837],
        [8.473753355, 50.099362958],
        [8.474123671, 50.099191579],
        [8.474099068, 50.099163885],
        [8.47350418, 50.098454775],
        [8.474152577, 50.098228552],
        [8.474912421, 50.097959282],
        [8.475485154, 50.097749843],
        [8.476310368, 50.097387339],
        [8.477528101, 50.09685169],
        [8.478289898, 50.096501023],
        [8.478763927, 50.096282557],
        [8.478749411, 50.096272549],
        [8.479296898, 50.096019936],
        [8.479709161, 50.095829722],
        [8.479809082, 50.095783643],
        [8.479821443, 50.095777936],
        [8.479883806, 50.095749184],
        [8.479881997, 50.095748428],
        [8.479421127, 50.095555828],
        [8.478485965, 50.095165008],
        [8.478481574, 50.095163174],
        [8.478503094, 50.095142808],
        [8.478529104, 50.0951182],
        [8.478548505, 50.095099911],
        [8.478618727, 50.095033374],
        [8.47972762, 50.093983928],
        [8.479981378, 50.093743765],
        [8.479838109, 50.093639366],
        [8.479737631, 50.093566148],
        [8.481693612, 50.092434338],
        [8.481737359, 50.092409027],
        [8.48174754, 50.092403131],
        [8.481853236, 50.092341967],
        [8.481855385, 50.092340723],
        [8.481445049, 50.092022692],
        [8.481454512, 50.092014424],
        [8.481512202, 50.091964015],
        [8.481518384, 50.091960895],
        [8.481557794, 50.091941275],
        [8.48158442, 50.091927926],
        [8.483735016, 50.090855244],
        [8.483805334, 50.090820161],
        [8.48433932, 50.090553889],
        [8.48461268, 50.090417576],
        [8.484726593, 50.090360641],
        [8.485450371, 50.089998865],
        [8.485489014, 50.089978807],
        [8.485243527, 50.089752958],
        [8.485221446, 50.089732643],
        [8.485185495, 50.08969957],
        [8.48664848, 50.088948512],
        [8.487920448, 50.088295484],
        [8.487912796, 50.088279177],
        [8.487909722, 50.088272637],
        [8.487376034, 50.087126219],
        [8.487362018, 50.087096103],
        [8.486999397, 50.086317166],
        [8.486959886, 50.086232292],
        [8.48695033, 50.086211519],
        [8.487073508, 50.086170572],
        [8.487075886, 50.086169781],
        [8.487312444, 50.086090127],
        [8.487735048, 50.085947811],
        [8.487840852, 50.08591218],
        [8.487860976, 50.0859054],
        [8.487859359, 50.085900523],
        [8.487857943, 50.085896253],
        [8.487793288, 50.085700984],
        [8.487789107, 50.085688384],
        [8.487749074, 50.08556747],
        [8.487725207, 50.085495433],
        [8.487668391, 50.085323825],
        [8.48766445, 50.085311949],
        [8.487600013, 50.085117353],
        [8.487597764, 50.085110561],
        [8.487533153, 50.084915442],
        [8.487537033, 50.084914039],
        [8.487603174, 50.084890127],
        [8.487634286, 50.084878848],
        [8.488421578, 50.084594235],
        [8.488605039, 50.084527902],
        [8.48867972, 50.0845009],
        [8.488903047, 50.084420159],
        [8.488906437, 50.084428777],
        [8.489087778, 50.084889777],
        [8.489105977, 50.084891889],
        [8.489364397, 50.084919691],
        [8.490077314, 50.084996793],
        [8.490718663, 50.085066144],
        [8.490912716, 50.085087133],
        [8.491032671, 50.085100416],
        [8.491231199, 50.085122404],
        [8.491519354, 50.085154322],
        [8.491602666, 50.085170959],
        [8.491856615, 50.085221652],
        [8.492125496, 50.085275341],
        [8.492409173, 50.08533197],
        [8.492778108, 50.085392936],
        [8.493034452, 50.085435293],
        [8.493359795, 50.08548905],
        [8.493482435, 50.085509313],
        [8.494720135, 50.085701656],
        [8.494742822, 50.085855441],
        [8.49474441, 50.085866205],
        [8.495076298, 50.085915019],
        [8.494842627, 50.084795118],
        [8.494768977, 50.084442132],
        [8.494759596, 50.084404152],
        [8.494767918, 50.084399521],
        [8.494870066, 50.084342689],
        [8.494980102, 50.084281043],
        [8.495666717, 50.083891266],
        [8.49587807, 50.083771283],
        [8.495879193, 50.083770659],
        [8.495917406, 50.083750866],
        [8.49708234, 50.083145392],
        [8.49759407, 50.082892242],
        [8.497650108, 50.082864605],
        [8.498632006, 50.082378904],
        [8.498718926, 50.082335845],
        [8.498769765, 50.082310712],
        [8.49878311, 50.082304119],
        [8.498791955, 50.082299749],
        [8.498709353, 50.082120681],
        [8.498707516, 50.0821167],
        [8.498711019, 50.082105964],
        [8.498721915, 50.082075766],
        [8.498729814, 50.082068607],
        [8.498743266, 50.082056648],
        [8.49875125, 50.082049551],
        [8.499883622, 50.081602795],
        [8.500117633, 50.081551586],
        [8.500355595, 50.081535301],
        [8.50135785, 50.081466704],
        [8.501555167, 50.081433018],
        [8.501570469, 50.081430405],
        [8.501586096, 50.081426622],
        [8.501825813, 50.081368579],
        [8.50183787, 50.08136566],
        [8.501892387, 50.081336046],
        [8.501782731, 50.080979808],
        [8.501540494, 50.080192845],
        [8.501490381, 50.080121156],
        [8.501416741, 50.079689392],
        [8.501351164, 50.079304895],
        [8.501341801, 50.079244331],
        [8.501242046, 50.078655624],
        [8.501131953, 50.077991587],
        [8.501124103, 50.077872256],
        [8.501119666, 50.077804811],
        [8.501113401, 50.077782815],
        [8.501053593, 50.077572815],
        [8.501003255, 50.077396066],
        [8.500746663, 50.076550062],
        [8.50075806, 50.076480392],
        [8.500758105, 50.076480121],
        [8.50085314, 50.076353819],
        [8.500968815, 50.0761987],
        [8.500976156, 50.076188766],
        [8.500998752, 50.076158188],
        [8.501005072, 50.076149633],
        [8.501285937, 50.076273166],
        [8.501329154, 50.076292174],
        [8.501362654, 50.076306972],
        [8.501363259, 50.076232246],
        [8.501363749, 50.076171571],
        [8.501364224, 50.076112336],
        [8.501364702, 50.076053991],
        [8.501364972, 50.076019783],
        [8.501366078, 50.075884743],
        [8.501366391, 50.075845132],
        [8.501366791, 50.075795615],
        [8.501367604, 50.075695681],
        [8.50136856, 50.075577748],
        [8.501368585, 50.075556495],
        [8.50136913, 50.075503814],
        [8.501369806, 50.075423802],
        [8.501580511, 50.075375438],
        [8.50200794, 50.075277217],
        [8.502026896, 50.075262392],
        [8.502026961, 50.075262342],
        [8.50209074, 50.075212463],
        [8.502103119, 50.075202734],
        [8.502112063, 50.075195661],
        [8.502112471, 50.075195384],
        [8.50224169, 50.075094364],
        [8.502256269, 50.075086704],
        [8.502267097, 50.075081167],
        [8.502484928, 50.074967562],
        [8.502529452, 50.07494435],
        [8.502669526, 50.074871318],
        [8.502771592, 50.074818109],
        [8.502883615, 50.074762695],
        [8.502945719, 50.07473197],
        [8.50309658, 50.074657339],
        [8.503206902, 50.074602762],
        [8.503223509, 50.074596334],
        [8.503297786, 50.074567791],
        [8.503370774, 50.074539703],
        [8.503520213, 50.0744822],
        [8.503669735, 50.074424663],
        [8.503739763, 50.074397711],
        [8.503827607, 50.07437027],
        [8.503960829, 50.074328656],
        [8.504130378, 50.074275707],
        [8.504232797, 50.074243706],
        [8.504296143, 50.074223918],
        [8.504361619, 50.074203466],
        [8.504378886, 50.074197966],
        [8.504490945, 50.074163075],
        [8.504612227, 50.074125194],
        [8.504732751, 50.074087543],
        [8.504851623, 50.074038108],
        [8.504970494, 50.073988673],
        [8.505139591, 50.073918342],
        [8.505271369, 50.073863539],
        [8.505513474, 50.073747668],
        [8.505603698, 50.073704475],
        [8.505697855, 50.07365942],
        [8.505789763, 50.073615425],
        [8.505878752, 50.073572829],
        [8.5059562, 50.073535758],
        [8.506031291, 50.073499819],
        [8.506104149, 50.073464949],
        [8.506229679, 50.073404861],
        [8.506293567, 50.073374286],
        [8.506420218, 50.073313662],
        [8.506547993, 50.073252503],
        [8.50664383, 50.073206637],
        [8.506748624, 50.073156484],
        [8.506819236, 50.073122682],
        [8.506968656, 50.073051169],
        [8.507073112, 50.073001164],
        [8.507080946, 50.072997414],
        [8.507078865, 50.072995877],
        [8.507058078, 50.072979696],
        [8.505831908, 50.071984094],
        [8.50580171, 50.071959242],
        [8.505794878, 50.071953652],
        [8.505785364, 50.071945867],
        [8.505918237, 50.071898181],
        [8.506107571, 50.071789229],
        [8.506232011, 50.07171762],
        [8.506439751, 50.071565972],
        [8.506494916, 50.071525703],
        [8.506972458, 50.071274293],
        [8.507100229, 50.071207026],
        [8.507359385, 50.071137189],
        [8.507761775, 50.071028754],
        [8.508128335, 50.070823984],
        [8.508405317, 50.070669254],
        [8.50849914, 50.070597035],
        [8.50860054, 50.070518762],
        [8.508601186, 50.070518006],
        [8.508773139, 50.070317027],
        [8.509167391, 50.06995431],
        [8.509854207, 50.069156063],
        [8.509994433, 50.069018732],
        [8.510085787, 50.068881205],
        [8.510153936, 50.068807213],
        [8.510490124, 50.068442198],
        [8.510613576, 50.068260386],
        [8.51067445, 50.068170735],
        [8.510930093, 50.067829096],
        [8.510948772, 50.067842634],
        [8.510955607, 50.06784758],
        [8.510988885, 50.067871689],
        [8.511033172, 50.067851331],
        [8.513721465, 50.066623335],
        [8.513832163, 50.066572769],
        [8.514019278, 50.066487298],
        [8.514028651, 50.066494843],
        [8.514064931, 50.066524052],
        [8.514089329, 50.066543691],
        [8.51410328, 50.066554916],
        [8.514126377, 50.066543599],
        [8.514627252, 50.066298172],
        [8.514669462, 50.066300377],
        [8.51472603, 50.066303331],
        [8.51500377, 50.06616843],
        [8.51624267, 50.065566667],
        [8.516532875, 50.065426222],
        [8.516543575, 50.065434623],
        [8.516616311, 50.065491741],
        [8.516639924, 50.065510287],
        [8.516915133, 50.065376233],
        [8.517118267, 50.065277275],
        [8.5171702, 50.065251976],
        [8.517634167, 50.065025969],
        [8.517791939, 50.064949111],
        [8.517800877, 50.064944757],
        [8.517167715, 50.064235077],
        [8.517165009, 50.064232043],
        [8.517249377, 50.064179116],
        [8.51730813, 50.064142258],
        [8.517328228, 50.064129754],
        [8.51735843, 50.06411109],
        [8.517410877, 50.064078762],
        [8.517457224, 50.064050149],
        [8.517503559, 50.064021527],
        [8.517563141, 50.063982396],
        [8.517590178, 50.063963108],
        [8.51765562, 50.063918966],
        [8.517715283, 50.063878721],
        [8.51777496, 50.063838476],
        [8.517933741, 50.063731375],
        [8.517993873, 50.063688758],
        [8.518033331, 50.0636608],
        [8.518079368, 50.063628175],
        [8.518209958, 50.06353563],
        [8.518309546, 50.063465055],
        [8.518409134, 50.063394478],
        [8.518621737, 50.063244213],
        [8.518706259, 50.063184327],
        [8.518845925, 50.063085006],
        [8.518871368, 50.063066912],
        [8.518873758, 50.063065277],
        [8.518979886, 50.062984371],
        [8.519085251, 50.062904234],
        [8.519191905, 50.062809647],
        [8.51930094, 50.062713019],
        [8.519368182, 50.062653403],
        [8.519400865, 50.062625129],
        [8.519573495, 50.062481447],
        [8.51980045, 50.062291374],
        [8.520120207, 50.062023576],
        [8.520205706, 50.061952096],
        [8.520294113, 50.061863006],
        [8.520301353, 50.061855711],
        [8.520388186, 50.061768222],
        [8.520398096, 50.061772048],
        [8.521543559, 50.062214234],
        [8.521971795, 50.062379543],
        [8.522016707, 50.062404597],
        [8.523892938, 50.063451221],
        [8.525666089, 50.064449624],
        [8.526756856, 50.065593186],
        [8.52699616, 50.066252224],
        [8.527143783, 50.06701128],
        [8.527145071, 50.067017898],
        [8.527140258, 50.067080049],
        [8.527091912, 50.06770439],
        [8.527076366, 50.067905162],
        [8.527041332, 50.068126998],
        [8.526961696, 50.068631247],
        [8.526682629, 50.0694599],
        [8.525967121, 50.070636535],
        [8.524421929, 50.072220601],
        [8.523817494, 50.073022741],
        [8.52381193, 50.0730345],
        [8.523721297, 50.073226042],
        [8.523420912, 50.073860857],
        [8.523354798, 50.074054989],
        [8.522973069, 50.075175846],
        [8.52282917, 50.075598191],
        [8.522560857, 50.07638512],
        [8.522121143, 50.077676095],
        [8.522117281, 50.077687434],
        [8.522126282, 50.078898425],
        [8.522132753, 50.078914685],
        [8.522476303, 50.079777927],
        [8.522522999, 50.079895259],
        [8.522842112, 50.08042383],
        [8.522917446, 50.080548528],
        [8.523018618, 50.080715989],
        [8.523023906, 50.08072471],
        [8.523027996, 50.080731498],
        [8.523053838, 50.080774246],
        [8.52380422, 50.082015873],
        [8.5238288, 50.082056543],
        [8.525156512, 50.083439332],
        [8.525684451, 50.083861582],
        [8.526586049, 50.083396014],
        [8.526596582, 50.083390572],
        [8.526651634, 50.083362108],
        [8.526655285, 50.083360235],
        [8.526698537, 50.083337935],
        [8.527291859, 50.08303259],
        [8.527301689, 50.083027524],
        [8.527484841, 50.082933286],
        [8.527616252, 50.082865672],
        [8.527786437, 50.082778106],
        [8.527887603, 50.082726057],
        [8.528487185, 50.082417549],
        [8.529123791, 50.082089967],
        [8.529287333, 50.082035373],
        [8.529622028, 50.081923637],
        [8.529866489, 50.081842037],
        [8.530035816, 50.081785507],
        [8.530855552, 50.081511848],
        [8.530839274, 50.081496129],
        [8.530525454, 50.081193082],
        [8.530308705, 50.080983786],
        [8.529962639, 50.080649602],
        [8.529963501, 50.080648991],
        [8.531142796, 50.079813252],
        [8.531459744, 50.079588631],
        [8.531803861, 50.079344767],
        [8.532388006, 50.078790623],
        [8.532409538, 50.078770193],
        [8.532517975, 50.078724589],
        [8.534743856, 50.078448346],
        [8.534868299, 50.078468003],
        [8.534857753, 50.078424301],
        [8.534849493, 50.07839007],
        [8.534854157, 50.078386367],
        [8.535808817, 50.077628139],
        [8.535856276, 50.077590388],
        [8.535904141, 50.077552371],
        [8.535993694, 50.077481164],
        [8.536024117, 50.077457021],
        [8.536186733, 50.077327848],
        [8.536256319, 50.077298907],
        [8.536367968, 50.077254229],
        [8.536443293, 50.077224142],
        [8.536507945, 50.077198248],
        [8.536676685, 50.077130863],
        [8.536692882, 50.077124437],
        [8.536781796, 50.077088838],
        [8.536915231, 50.077035476],
        [8.537118083, 50.076954351],
        [8.537680153, 50.076730003],
        [8.539248502, 50.076513536],
        [8.539432572, 50.076488129],
        [8.539440837, 50.076486988],
        [8.540141224, 50.076430326],
        [8.540209018, 50.076424831],
        [8.54032239, 50.076415642],
        [8.540536837, 50.076398743],
        [8.540780235, 50.076378631],
        [8.540993968, 50.076362007],
        [8.541039439, 50.076340242],
        [8.541132762, 50.07629448],
        [8.541384257, 50.076172187],
        [8.541501297, 50.076115192],
        [8.541560792, 50.076086198],
        [8.541685956, 50.076008168],
        [8.541812333, 50.075929382],
        [8.541918698, 50.075863434],
        [8.54217375, 50.075704742],
        [8.542844159, 50.075287555],
        [8.542862473, 50.074131715],
        [8.54286421, 50.07402209],
        [8.542864915, 50.073977141],
        [8.542865982, 50.073973107],
        [8.542887794, 50.073890644],
        [8.54334882, 50.072149252],
        [8.543359207, 50.072110139],
        [8.543359249, 50.072109983],
        [8.543382109, 50.072023903],
        [8.543592762, 50.071227983],
        [8.543599993, 50.0712005],
        [8.543604729, 50.071196443],
        [8.543655646, 50.071152823],
        [8.543673661, 50.071137389],
        [8.54366898, 50.071155033],
        [8.5436683, 50.071157597],
        [8.544356232, 50.071274879],
        [8.544560885, 50.071409404],
        [8.544562011, 50.071407518],
        [8.544595233, 50.07135191],
        [8.544624396, 50.071310929],
        [8.544649172, 50.071275963],
        [8.544763293, 50.071115276],
        [8.544777732, 50.071095014],
        [8.544790032, 50.071079419],
        [8.544888713, 50.070953639],
        [8.544952219, 50.07087269],
        [8.545000854, 50.070823296],
        [8.545226694, 50.070593928],
        [8.545468988, 50.070394354],
        [8.545689689, 50.070231394],
        [8.54580536, 50.070152974],
        [8.545860683, 50.070115469],
        [8.545896064, 50.070091482],
        [8.546065471, 50.069990633],
        [8.546268916, 50.069881188],
        [8.546303816, 50.069870126],
        [8.546321875, 50.069864403],
        [8.546345851, 50.069846854],
        [8.546663376, 50.069614435],
        [8.5467247, 50.069569542],
        [8.546872438, 50.069461411],
        [8.547138056, 50.069267],
        [8.547150164, 50.069258137],
        [8.547640193, 50.06910621],
        [8.547931833, 50.068899128],
        [8.548000009, 50.068845195],
        [8.54816967, 50.068710975],
        [8.548221096, 50.06866538],
        [8.548310614, 50.068586013],
        [8.548354325, 50.068547258],
        [8.548482405, 50.06842102],
        [8.548717209, 50.068189591],
        [8.548868614, 50.068026193],
        [8.549097178, 50.067766907],
        [8.549260551, 50.067578122],
        [8.549376315, 50.067431676],
        [8.549564604, 50.067162082],
        [8.549765202, 50.066845732],
        [8.549840527, 50.066706968],
        [8.549912231, 50.066559418],
        [8.549990771, 50.066397804],
        [8.550127677, 50.066084761],
        [8.550135918, 50.066065918],
        [8.550121315, 50.066029183],
        [8.550119815, 50.066025407],
        [8.549964433, 50.066023947],
        [8.549949151, 50.066023803],
        [8.549953161, 50.066013209],
        [8.549970208, 50.065967686],
        [8.550007738, 50.065867479],
        [8.550151328, 50.065868893],
        [8.55016583, 50.065869035],
        [8.550166029, 50.065868538],
        [8.550196864, 50.06579146],
        [8.550377925, 50.065172955],
        [8.550383943, 50.065152514],
        [8.550384271, 50.065151402],
        [8.550290189, 50.065168888],
        [8.550289655, 50.065168987],
        [8.550283815, 50.065170073],
        [8.55029438, 50.065115623],
        [8.550351019, 50.065105144],
        [8.550391477, 50.065097658],
        [8.550391648, 50.065095687],
        [8.550392887, 50.065081391],
        [8.550436493, 50.06454607],
        [8.550440684, 50.064494637],
        [8.550432186, 50.064028531],
        [8.550348646, 50.063477364],
        [8.550413438, 50.063448665],
        [8.550403759, 50.063437062],
        [8.550216484, 50.063212525],
        [8.550133446, 50.063175973],
        [8.550118961, 50.063115161],
        [8.550117455, 50.063108841],
        [8.550248405, 50.062979895],
        [8.550247906, 50.062974583],
        [8.550245356, 50.062947429],
        [8.550250538, 50.062796283],
        [8.550250898, 50.062785712],
        [8.550250923, 50.062784993],
        [8.550247049, 50.062784276],
        [8.550178425, 50.062771586],
        [8.549980884, 50.061970961],
        [8.550084133, 50.06192744],
        [8.550270069, 50.061849064],
        [8.550288787, 50.061841171],
        [8.550487377, 50.061723455],
        [8.55049587, 50.0617154],
        [8.550545905, 50.061667948],
        [8.550770314, 50.061455123],
        [8.550843644, 50.061360813],
        [8.550910394, 50.061274965],
        [8.551028425, 50.060974701],
        [8.55102681, 50.060859646],
        [8.551024061, 50.060663814],
        [8.550992061, 50.060604799],
        [8.550898025, 50.060431382],
        [8.550688752, 50.060229287],
        [8.550632164, 50.060194958],
        [8.550494987, 50.060111701],
        [8.550488229, 50.060107598],
        [8.55048308, 50.060105351],
        [8.550098963, 50.059937754],
        [8.549943566, 50.05986995],
        [8.549705462, 50.059721754],
        [8.549676567, 50.05970377],
        [8.549581247, 50.059577634],
        [8.549604948, 50.059463916],
        [8.549866045, 50.059140546],
        [8.5503028, 50.058599608],
        [8.550312153, 50.058574356],
        [8.550495082, 50.058080453],
        [8.550708804, 50.057521652],
        [8.550733852, 50.057456127],
        [8.550738003, 50.057445364],
        [8.550847166, 50.057449634],
        [8.550862467, 50.057447266],
        [8.551016102, 50.057423487],
        [8.551010619, 50.057408832],
        [8.550967869, 50.057294584],
        [8.550949203, 50.057244624],
        [8.55085289, 50.056986981],
        [8.550789531, 50.056774589],
        [8.550645372, 50.056258826],
        [8.550583465, 50.055491253],
        [8.550592433, 50.055270637],
        [8.550594158, 50.055228207],
        [8.55059012, 50.0552273],
        [8.550341676, 50.055171489],
        [8.550005737, 50.055096117],
        [8.549939128, 50.055081294],
        [8.549927424, 50.055078641],
        [8.549874626, 50.05506675],
        [8.549906417, 50.054980556],
        [8.549944235, 50.054885808],
        [8.549978621, 50.054791145],
        [8.550012319, 50.054695105],
        [8.550031995, 50.054643666],
        [8.550050839, 50.054605971],
        [8.550093681, 50.054514596],
        [8.550135681, 50.054428243],
        [8.550174874, 50.054340487],
        [8.550179392, 50.054330676],
        [8.550188918, 50.054309993],
        [8.550195182, 50.054296395],
        [8.550216231, 50.054250931],
        [8.550336547, 50.0539932],
        [8.550374197, 50.053906058],
        [8.55038089, 50.053890575],
        [8.550413892, 50.053822546],
        [8.550456075, 50.053738792],
        [8.550498266, 50.05365574],
        [8.550538694, 50.053574516],
        [8.550580281, 50.053494751],
        [8.550580873, 50.053491229],
        [8.550625236, 50.053411817],
        [8.550714991, 50.053253204],
        [8.550760045, 50.05317446],
        [8.550766007, 50.053163965],
        [8.550782405, 50.053135097],
        [8.550803694, 50.053096637],
        [8.550808935, 50.053087208],
        [8.550847335, 50.053018122],
        [8.550895962, 50.052942547],
        [8.550942814, 50.052867208],
        [8.550988294, 50.05279644],
        [8.55103273, 50.052728653],
        [8.551079261, 50.052656064],
        [8.551135912, 50.052565848],
        [8.551153752, 50.052537903],
        [8.551449748, 50.052075642],
        [8.551550546, 50.051945889],
        [8.551594647, 50.05188912],
        [8.551590237, 50.051884805],
        [8.551574151, 50.051869066],
        [8.551558117, 50.051853377],
        [8.551544109, 50.05184838],
        [8.55150998, 50.051836208],
        [8.551533335, 50.051803663],
        [8.551541715, 50.051806653],
        [8.551584534, 50.051821931],
        [8.551604326, 50.051815945],
        [8.551675017, 50.051794563],
        [8.551885101, 50.05156214],
        [8.55206804, 50.051359745],
        [8.552524535, 50.050781701],
        [8.552712019, 50.050523651],
        [8.5527116, 50.050523469],
        [8.552560872, 50.050457718],
        [8.552713226, 50.050262849],
        [8.552771627, 50.05018815],
        [8.552931107, 50.050228502],
        [8.553208776, 50.049957942],
        [8.553453558, 50.049637403],
        [8.553491851, 50.049587257],
        [8.552498436, 50.049272734],
        [8.552507714, 50.049261062],
        [8.552547456, 50.049211069],
        [8.552758711, 50.049255576],
        [8.552826855, 50.049269773],
        [8.552873404, 50.049278853],
        [8.552987958, 50.049302121],
        [8.55300152, 50.049285091],
        [8.553020666, 50.049261126],
        [8.55304355, 50.049232483],
        [8.553270622, 50.048948264],
        [8.553283599, 50.048932635],
        [8.55316824, 50.048907413],
        [8.553161133, 50.048905858],
        [8.553092003, 50.048892826],
        [8.553080047, 50.048887206],
        [8.552406443, 50.048761363],
        [8.551145894, 50.048482291],
        [8.551087236, 50.048469298],
        [8.549781186, 50.048170888],
        [8.549561153, 50.048110428],
        [8.549150122, 50.048018759],
        [8.548922718, 50.047968779],
        [8.548927657, 50.047963224],
        [8.548818641, 50.047935129],
        [8.548544477, 50.047864459],
        [8.548474647, 50.047926312],
        [8.547953877, 50.047775414],
        [8.547057816, 50.047504404],
        [8.546179234, 50.047231712],
        [8.545284286, 50.04693525],
        [8.544435161, 50.046638269],
        [8.543609879, 50.046333733],
        [8.542787085, 50.046005152],
        [8.541849082, 50.045622106],
        [8.540893555, 50.045251037],
        [8.540004532, 50.0448939],
        [8.538870574, 50.044435225],
        [8.538854159, 50.044429046],
        [8.537985821, 50.044098901],
        [8.538047602, 50.044041616],
        [8.537721245, 50.043910308],
        [8.537714769, 50.043915946],
        [8.537650487, 50.043972051],
        [8.53699541, 50.043713422],
        [8.536500055, 50.04349626],
        [8.536050525, 50.04329904],
        [8.536001164, 50.043281045],
        [8.535085648, 50.042947279],
        [8.534146032, 50.042572938],
        [8.533098059, 50.042143843],
        [8.532055426, 50.041731831],
        [8.531131733, 50.041351488],
        [8.530429187, 50.040997474],
        [8.529766632, 50.040788085],
        [8.528829859, 50.040409891],
        [8.527989433, 50.040096318],
        [8.527269393, 50.039808059],
        [8.526704074, 50.039553684],
        [8.526373575, 50.039404273],
        [8.526161637, 50.039308478],
        [8.525962164, 50.039236819],
        [8.525292186, 50.038995935],
        [8.524458384, 50.038659527],
        [8.523813745, 50.038408678],
        [8.523706977, 50.038367064],
        [8.523135552, 50.038176297],
        [8.52320883, 50.038119238],
        [8.523239482, 50.03809536],
        [8.522849865, 50.037946856],
        [8.522815334, 50.037966134],
        [8.522728882, 50.038014427],
        [8.521796437, 50.037634763],
        [8.520823641, 50.037237782],
        [8.519797145, 50.036845353],
        [8.519873275, 50.036783633],
        [8.520089281, 50.036608672],
        [8.520420768, 50.036046347],
        [8.520616777, 50.035713151],
        [8.52081914, 50.035368229],
        [8.521565923, 50.034099289],
        [8.521604838, 50.034032974],
        [8.520398502, 50.033737554],
        [8.520192581, 50.033687256],
        [8.519219196, 50.033449659],
        [8.518728399, 50.033329843],
        [8.516710002, 50.03283792],
        [8.516646727, 50.032822498],
        [8.516805705, 50.032546612],
        [8.517260992, 50.031757854],
        [8.517864709, 50.030711308],
        [8.518932246, 50.02886166],
        [8.519485376, 50.027903303],
        [8.519505562, 50.027868328],
        [8.517706065, 50.027436583],
        [8.516408163, 50.027126793],
        [8.516334958, 50.027109319],
        [8.517077354, 50.025821454],
        [8.518280262, 50.02373962],
        [8.51843227, 50.023472963],
        [8.519184282, 50.022169552],
        [8.519987482, 50.020777305],
        [8.520121948, 50.020783949],
        [8.520747768, 50.020814868],
        [8.520818341, 50.020818306],
        [8.521875984, 50.020870225],
        [8.523469919, 50.020949561],
        [8.526762359, 50.021109727],
        [8.531489552, 50.021342052],
        [8.532018134, 50.021468593],
        [8.533941037, 50.021932978],
        [8.536321892, 50.022633425],
        [8.537751548, 50.023053997],
        [8.538504691, 50.02327619],
        [8.538581543, 50.023298862],
        [8.54114734, 50.023892381],
        [8.541408211, 50.023952731],
        [8.543032251, 50.02432837],
        [8.543272966, 50.024368911],
        [8.54433431, 50.024547616],
        [8.548535223, 50.02525484],
        [8.54855211, 50.025257683],
        [8.548720692, 50.025286465],
        [8.548776655, 50.02529602],
        [8.548914293, 50.025291849],
        [8.549063055, 50.025287341],
        [8.549093208, 50.025286479],
        [8.550777969, 50.02523863],
        [8.550917589, 50.025257696],
        [8.552124296, 50.025422479],
        [8.552837539, 50.025492352],
        [8.553534485, 50.025560624],
        [8.555703408, 50.02584091],
        [8.556425036, 50.025934192],
        [8.557572234, 50.026015767],
        [8.558995969, 50.025839093],
        [8.559040159, 50.025833609],
        [8.560691201, 50.026108924],
        [8.561568217, 50.026255157],
        [8.562846851, 50.026589519],
        [8.563013668, 50.02663314],
        [8.564438054, 50.026347053],
        [8.565883003, 50.026070574],
        [8.567949124, 50.025745321],
        [8.568963385, 50.0255485],
        [8.56950648, 50.025443106],
        [8.569803719, 50.025318979],
        [8.570022428, 50.025371279],
        [8.570088218, 50.025387011],
        [8.57010605, 50.025357285],
        [8.571125868, 50.023657148],
        [8.572234235, 50.02180745],
        [8.572251136, 50.021782007],
        [8.572679804, 50.021091343],
        [8.574612944, 50.018777748],
        [8.574899788, 50.018135888],
        [8.574937671, 50.018044135],
        [8.575531308, 50.01660583],
        [8.575683863, 50.016350701],
        [8.57597317, 50.015866861],
        [8.575988055, 50.0158243],
        [8.576106728, 50.015485234],
        [8.576153111, 50.015352865],
        [8.576157276, 50.015355227],
        [8.57816409, 50.016470366],
        [8.578469989, 50.016549016],
        [8.579372683, 50.0167811],
        [8.580456436, 50.016946694],
        [8.581015674, 50.017515878],
        [8.581137597, 50.017535106],
        [8.581207353, 50.017536069],
        [8.583352042, 50.017566687],
        [8.58411556, 50.017658292],
        [8.585008954, 50.017765472],
        [8.585495052, 50.017823689],
        [8.585760573, 50.017855489],
        [8.585823233, 50.017854183],
        [8.590981378, 50.017749492],
        [8.591488692, 50.017700661],
        [8.591833188, 50.017702861],
        [8.591867791, 50.017703072],
        [8.592014204, 50.017704108],
        [8.592036791, 50.01774737],
        [8.592129131, 50.01792424],
        [8.59216556, 50.018021914],
        [8.592206491, 50.01813175],
        [8.592233916, 50.018205209],
        [8.592279738, 50.01834733],
        [8.592303782, 50.0183821],
        [8.592514754, 50.018687186],
        [8.592463757, 50.018728273],
        [8.592366716, 50.01908117],
        [8.592268814, 50.019571994],
        [8.592104427, 50.020335073],
        [8.592007806, 50.020783581],
        [8.591826885, 50.021680033],
        [8.591703665, 50.022223578],
        [8.591623048, 50.022579193],
        [8.59147263, 50.023497141],
        [8.591436214, 50.023817101],
        [8.591374327, 50.024360825],
        [8.59138622, 50.025207267],
        [8.591402503, 50.025752704],
        [8.591400394, 50.026276643],
        [8.591504396, 50.026605646],
        [8.59163233, 50.027322215],
        [8.591730801, 50.027886165],
        [8.591910654, 50.02854391],
        [8.592056305, 50.029010029],
        [8.592232897, 50.029445608],
        [8.592407923, 50.029886666],
        [8.592550165, 50.030227409],
        [8.592776349, 50.03080877],
        [8.592815368, 50.030880291],
        [8.593147536, 50.031488059],
        [8.593173071, 50.031538496],
        [8.593347929, 50.031882193],
        [8.593628153, 50.032432949],
        [8.593726174, 50.032625157],
        [8.593845333, 50.032859785],
        [8.593972425, 50.033109652],
        [8.594107415, 50.033375045],
        [8.594636241, 50.034414175],
        [8.594643235, 50.034412402],
        [8.594828566, 50.034774698],
        [8.594944679, 50.035000971],
        [8.595489241, 50.036077119],
        [8.595873869, 50.036837423],
        [8.59597694, 50.037057684],
        [8.596171846, 50.037474186],
        [8.596559673, 50.038302923],
        [8.596644002, 50.038481101],
        [8.596779617, 50.038771369],
        [8.596982881, 50.039203032],
        [8.597039196, 50.039366291],
        [8.597050754, 50.039399799],
        [8.597291011, 50.039843869],
        [8.597344283, 50.039942068],
        [8.597542041, 50.040349103],
        [8.597898392, 50.041086574],
        [8.598138431, 50.041570632],
        [8.598428117, 50.042156642],
        [8.598475757, 50.042252915],
        [8.598486471, 50.042249307],
        [8.599123227, 50.042034884],
        [8.59938259, 50.041947771],
        [8.59945151, 50.041924355],
        [8.599490013, 50.041911398],
        [8.599658838, 50.041854584],
        [8.600729265, 50.041148413],
        [8.600908807, 50.041029964],
        [8.600913636, 50.041028525],
        [8.601561045, 50.040835618],
        [8.602452154, 50.040570087],
        [8.602929704, 50.040427783],
        [8.603343784, 50.04030441],
        [8.603792497, 50.040142],
        [8.604783014, 50.039783469],
        [8.604785496, 50.039782571],
        [8.604821552, 50.039767507],
        [8.604821625, 50.039767477],
        [8.605141902, 50.03963367],
        [8.606333701, 50.039135739],
        [8.606390372, 50.039113977],
        [8.606398941, 50.039128663],
        [8.606989163, 50.040140231],
        [8.608120699, 50.041866224],
        [8.608215506, 50.042010833],
        [8.608220711, 50.042020804],
        [8.608425436, 50.042413027],
        [8.608745838, 50.043028548],
        [8.608813081, 50.043158047],
        [8.608920373, 50.043364673],
        [8.608967028, 50.043454524],
        [8.608974524, 50.043468959],
        [8.609362828, 50.043828148],
        [8.610001395, 50.044420165],
        [8.610451577, 50.044837519],
        [8.61072123, 50.045087503],
        [8.61086572, 50.045205923],
        [8.611073172, 50.045376483],
        [8.611343811, 50.045599177],
        [8.611567688, 50.045783391],
        [8.612014313, 50.046091106],
        [8.612061539, 50.046123925],
        [8.612070665, 50.046130268],
        [8.612157579, 50.046190668],
        [8.612616997, 50.046506919],
        [8.612876241, 50.046685372],
        [8.612978292, 50.046755837],
        [8.613906944, 50.047438252],
        [8.614141556, 50.047610533],
        [8.614415192, 50.047811469],
        [8.614982048, 50.048214313],
        [8.615955617, 50.04890617],
        [8.615963121, 50.048911503],
        [8.616141778, 50.049006313],
        [8.617746574, 50.049856856],
        [8.617959755, 50.049969839],
        [8.617971215, 50.049975656],
        [8.618025245, 50.050004289],
        [8.618084338, 50.050035599],
        [8.618836466, 50.050460126],
        [8.619198247, 50.050664323],
        [8.619651007, 50.050896662],
        [8.620362146, 50.051261691],
        [8.62046986, 50.05131698],
        [8.620834293, 50.051523464],
        [8.621412535, 50.051851084],
        [8.621547918, 50.051927754],
        [8.62168724, 50.052006664],
        [8.621699412, 50.052013558],
        [8.621714008, 50.05202719],
        [8.621784369, 50.052092851],
        [8.62207944, 50.05236827],
        [8.622162887, 50.052446048],
        [8.622198761, 50.052479501],
        [8.622305761, 50.052579364],
        [8.622511461, 50.052771235],
        [8.622635077, 50.05288654],
        [8.622934376, 50.053268605],
        [8.623295235, 50.053729661],
        [8.623327579, 50.053770986],
        [8.623344047, 50.053792026],
        [8.623756404, 50.054209361],
        [8.624208545, 50.054666949],
        [8.624621199, 50.055085024],
        [8.624771178, 50.055054009],
        [8.625330486, 50.054938345],
        [8.625355763, 50.054933118],
        [8.626048341, 50.054910223],
        [8.62611855, 50.054907902],
        [8.626276928, 50.054902845],
        [8.626282261, 50.054902675],
        [8.627554074, 50.05518955],
        [8.627604954, 50.055201041],
        [8.628972133, 50.055503733],
        [8.629763527, 50.055516496],
        [8.630924517, 50.055535275],
        [8.631018624, 50.055536832],
        [8.63219571, 50.055423264],
        [8.632309483, 50.055412286],
        [8.632312895, 50.055411957],
        [8.633316822, 50.055430052],
        [8.633442341, 50.055432255],
        [8.633488122, 50.055433119],
        [8.633629537, 50.055444358],
        [8.634043525, 50.055477258],
        [8.634569621, 50.055519579],
        [8.634719513, 50.055531636],
        [8.634788622, 50.055533482],
        [8.635180047, 50.055568515],
        [8.635190594, 50.05557007],
        [8.635678453, 50.055641982],
        [8.636581186, 50.055775041],
        [8.636726476, 50.055796455],
        [8.637057889, 50.055773747],
        [8.637206838, 50.055763504],
        [8.637958075, 50.055711805],
        [8.638838476, 50.05573096],
        [8.639160727, 50.055737976],
        [8.6394063, 50.055743293],
        [8.639546515, 50.05574633],
        [8.639552243, 50.055746454],
        [8.640670633, 50.055677876],
        [8.641203657, 50.055679604],
        [8.641272626, 50.055679821],
        [8.64203285, 50.055682222],
        [8.642808736, 50.055755346],
        [8.643774837, 50.055846308],
        [8.644030685, 50.055870389],
        [8.644058111, 50.055872969],
        [8.644346097, 50.055868718],
        [8.645481598, 50.055851981],
        [8.646192265, 50.055841501],
        [8.646200109, 50.055840403],
        [8.646438818, 50.055806999],
        [8.646670328, 50.055774619],
        [8.646811105, 50.055754908],
        [8.646813041, 50.055754784],
        [8.646968554, 50.055744858],
        [8.647436494, 50.055715048],
        [8.64817825, 50.055667791],
        [8.648557719, 50.055675962],
        [8.648923212, 50.055683943],
        [8.648992699, 50.055685448],
        [8.649119669, 50.055688177],
        [8.649562371, 50.055697793],
        [8.649673452, 50.055688418],
        [8.649772204, 50.055679919],
        [8.65089509, 50.055583273],
        [8.651311535, 50.05559982],
        [8.651939214, 50.055624757],
        [8.652537114, 50.05564845],
        [8.653041067, 50.055668418],
        [8.653074097, 50.05566973],
        [8.654506507, 50.055708389],
        [8.654836185, 50.055717284],
        [8.65500249, 50.055721994],
        [8.657026911, 50.055602516],
        [8.657222206, 50.055590987],
        [8.657226095, 50.055590758],
        [8.658329002, 50.055586714],
        [8.659473956, 50.055582749],
        [8.659502664, 50.05558265],
        [8.659523221, 50.055582323],
        [8.659823707, 50.055570344],
        [8.660455133, 50.055545167],
        [8.661180685, 50.055515943],
        [8.661851427, 50.055449843],
        [8.662993035, 50.05533733],
        [8.663228908, 50.055314181],
        [8.664015765, 50.055337675],
        [8.664869885, 50.055363141],
        [8.665180257, 50.055372393],
        [8.665318687, 50.055385549],
        [8.66534602, 50.055388089],
        [8.665652211, 50.055416537],
        [8.665685139, 50.055420407],
        [8.665833896, 50.055434491],
        [8.666192954, 50.055468599],
        [8.66622491, 50.055471657],
        [8.666362363, 50.055484818],
        [8.667329851, 50.055576658],
        [8.66758228, 50.055600656],
        [8.66773506, 50.055617107],
        [8.667784609, 50.055622443],
        [8.668569996, 50.055696321],
        [8.66982817, 50.055753421],
        [8.670163572, 50.055768632],
        [8.670184687, 50.05576959],
        [8.670408314, 50.055789534],
        [8.670408402, 50.055789542],
        [8.671775805, 50.055911485],
        [8.671960074, 50.05592407],
        [8.672096936, 50.055933737],
        [8.672377246, 50.055953538],
        [8.673402545, 50.056026073],
        [8.673891111, 50.056060475],
        [8.674147638, 50.056078492],
        [8.674164846, 50.056079708],
        [8.676054587, 50.056613527],
        [8.676372107, 50.056702877],
        [8.676395242, 50.056709873],
        [8.677727997, 50.057121407],
        [8.678076844, 50.057229296],
        [8.678078896, 50.057229931],
        [8.678269849, 50.057269041],
        [8.678589452, 50.0573345],
        [8.679568252, 50.057535197],
        [8.679790566, 50.05758078],
        [8.680939078, 50.057807976],
        [8.680991678, 50.057818381],
        [8.682374755, 50.058091124],
        [8.682919822, 50.058137452],
        [8.683516237, 50.058188142],
        [8.68365427, 50.058199954],
        [8.684449436, 50.058175967],
        [8.685874057, 50.058132979],
        [8.686241973, 50.058122231],
        [8.687526589, 50.058145946],
        [8.688421805, 50.058136471],
        [8.688562873, 50.05813488],
        [8.688582959, 50.058136624],
        [8.688789672, 50.058154565],
        [8.690211621, 50.058278034],
        [8.690597378, 50.058272435],
        [8.690823401, 50.058271894],
        [8.691911767, 50.058253365],
        [8.692045522, 50.058251088],
        [8.692788092, 50.058221514],
        [8.69417431, 50.058165571],
        [8.694444877, 50.058154685],
        [8.694467355, 50.058155909],
        [8.694496915, 50.058157517],
        [8.695007183, 50.058185291],
        [8.69527019, 50.058199285],
        [8.695325752, 50.058202209],
        [8.695558023, 50.058206441],
        [8.696288387, 50.058219741],
        [8.696442119, 50.05822284],
        [8.697030415, 50.058233804],
        [8.697288997, 50.058238623],
        [8.697431839, 50.058241332],
        [8.698428267, 50.058282105],
        [8.698626247, 50.058290204],
        [8.698641885, 50.058290784],
        [8.699304792, 50.058314374],
        [8.699435062, 50.058319008],
        [8.69961635, 50.058337466],
        [8.699865479, 50.058362564],
        [8.699890708, 50.058371291],
        [8.700305958, 50.058514936],
        [8.70046302, 50.058569193],
        [8.700465274, 50.058569537],
        [8.701481338, 50.058724659],
        [8.701493007, 50.058729073],
        [8.70192635, 50.05889303],
        [8.701961294, 50.058910472],
        [8.702965882, 50.059403685],
        [8.703808373, 50.059796125],
        [8.703877241, 50.05982109],
        [8.704115357, 50.059907408],
        [8.704956982, 50.06021183],
        [8.704981683, 50.060214411],
        [8.705134367, 50.060230261],
        [8.706349144, 50.060356261],
        [8.706616681, 50.060383368],
        [8.70685949, 50.060414377],
        [8.707260544, 50.060465733],
        [8.708067845, 50.060568904],
        [8.708123944, 50.060576058],
        [8.709012457, 50.060647151],
        [8.709390943, 50.060677471],
        [8.709463086, 50.06068325],
        [8.709602612, 50.060690519],
        [8.710759585, 50.060750782],
        [8.71147642, 50.060788085],
        [8.71180547, 50.060805442],
        [8.714121961, 50.060823486],
        [8.714718536, 50.060858102],
        [8.716067656, 50.060936371],
        [8.716565051, 50.060965176],
        [8.716637847, 50.060969535],
        [8.718667194, 50.061091039],
        [8.719009419, 50.061111133],
        [8.719019957, 50.061111752],
        [8.720611973, 50.06111503],
        [8.720665043, 50.061115247],
        [8.721455516, 50.061116343],
        [8.7223104, 50.061117534],
        [8.723580456, 50.061339835],
        [8.724479514, 50.061592585],
        [8.724962654, 50.061728405],
        [8.724970081, 50.061732017],
        [8.724994858, 50.061744063],
        [8.725040506, 50.061766259],
        [8.725011887, 50.061764663],
        [8.725024686, 50.06214187],
        [8.725031325, 50.062337595],
        [8.724898481, 50.062777426],
        [8.72488805, 50.062811958],
        [8.72478822, 50.062971235],
        [8.724623411, 50.063234177],
        [8.724243967, 50.063601947],
        [8.723764773, 50.063912624],
        [8.723754191, 50.063919485],
        [8.723059554, 50.064158425],
        [8.722762224, 50.064224139],
        [8.722482296, 50.064286007],
        [8.722442469, 50.065048989],
        [8.722448773, 50.065049188],
        [8.723551507, 50.065083844],
        [8.723973886, 50.06512827],
        [8.724007623, 50.065135684],
        [8.724010678, 50.065136355],
        [8.724289837, 50.065197697],
        [8.724315414, 50.065208282],
        [8.724397589, 50.065242289],
        [8.724917292, 50.065457361],
        [8.724965439, 50.06549109],
        [8.72501399, 50.065525188],
        [8.725089698, 50.065597102],
        [8.725226572, 50.06574467],
        [8.725299093, 50.065814688],
        [8.725398899, 50.065898256],
        [8.725451353, 50.065933461],
        [8.725506036, 50.065970161],
        [8.725545844, 50.065994341],
        [8.725665128, 50.066066995],
        [8.725691523, 50.066082902],
        [8.726001976, 50.066270008],
        [8.726003102, 50.066270687],
        [8.726038755, 50.066280009],
        [8.726825385, 50.066485675],
        [8.726879463, 50.066508602],
        [8.727218176, 50.066652201],
        [8.727455631, 50.066885161],
        [8.727455711, 50.06688524],
        [8.727608468, 50.067115383],
        [8.727823833, 50.067491128],
        [8.728061175, 50.068022526],
        [8.728090206, 50.068087526],
        [8.728180611, 50.068380995],
        [8.728221424, 50.068628767],
        [8.728254179, 50.068660078],
        [8.728786355, 50.069168789],
        [8.729311261, 50.069638033],
        [8.729478735, 50.069765564],
        [8.730075565, 50.070191567],
        [8.730175521, 50.070266878],
        [8.730289286, 50.070352587],
        [8.730492743, 50.070505895],
        [8.730406942, 50.070587047],
        [8.730382704, 50.070609973],
        [8.72997014, 50.070753225],
        [8.729718011, 50.070840769],
        [8.728749426, 50.071252763],
        [8.727773515, 50.07164322],
        [8.727719296, 50.071659528],
        [8.726843585, 50.071922924],
        [8.726010966, 50.072136528],
        [8.725930541, 50.072314501],
        [8.726027585, 50.072544595],
        [8.726060557, 50.072622773],
        [8.726134078, 50.072999118],
        [8.726140792, 50.07303348],
        [8.7262328, 50.073066422],
        [8.726517305, 50.073167927],
        [8.727070926, 50.07336546],
        [8.728157292, 50.073642372],
        [8.728209592, 50.073655702],
        [8.728340758, 50.073701857],
        [8.728378215, 50.073715037],
        [8.72839613, 50.073721363],
        [8.728495282, 50.073756279],
        [8.729157247, 50.07398937],
        [8.732057685, 50.074906909],
        [8.732278111, 50.074976635],
        [8.732573889, 50.075107838],
        [8.733279116, 50.075421225],
        [8.734331727, 50.075889274],
        [8.734103933, 50.0769878],
        [8.73421688, 50.077421617],
        [8.734374382, 50.078026554],
        [8.73375678, 50.078841872],
        [8.733713774, 50.078931525],
        [8.733326927, 50.079737973],
        [8.733311639, 50.079752157],
        [8.732822212, 50.080206211],
        [8.732521104, 50.08031219],
        [8.732517181, 50.080313589],
        [8.732501198, 50.080319291],
        [8.732471339, 50.080329616],
        [8.73155796, 50.0806529],
        [8.731572479, 50.080692365],
        [8.73160206, 50.080774695],
        [8.73190596, 50.081631468],
        [8.732023257, 50.081964274],
        [8.732191584, 50.082221211],
        [8.732470413, 50.082533737],
        [8.732470798, 50.082534236],
        [8.732536835, 50.082619957],
        [8.732853154, 50.083030561],
        [8.733078846, 50.083340176],
        [8.733280164, 50.083616104],
        [8.73337022, 50.083739896],
        [8.733378215, 50.083750886],
        [8.733698379, 50.08399],
        [8.733771997, 50.084044904],
        [8.733832922, 50.084090344],
        [8.733941305, 50.084171146],
        [8.734345163, 50.084472005],
        [8.735048489, 50.085445098],
        [8.735103317, 50.085529708],
        [8.7355374, 50.086199568],
        [8.735539432, 50.086201379],
        [8.73562995, 50.086282076],
        [8.736018904, 50.086625365],
        [8.736331773, 50.086756473],
        [8.736795012, 50.086950593],
        [8.736797612, 50.086951681],
        [8.737165015, 50.087267625],
        [8.737240104, 50.087332166],
        [8.737248587, 50.087339466],
        [8.737821822, 50.087930168],
        [8.738411381, 50.088325003],
        [8.738425164, 50.088334293],
        [8.738428862, 50.088337631],
        [8.738530449, 50.088429342],
        [8.738758421, 50.08863515],
        [8.73884522, 50.08872122],
        [8.739419875, 50.089291049],
        [8.739422258, 50.089295629],
        [8.739500619, 50.089446258],
        [8.739663326, 50.08975902],
        [8.740220488, 50.090156346],
        [8.740416128, 50.090295869],
        [8.740584399, 50.090415873],
        [8.740614496, 50.090440312],
        [8.741089496, 50.090825996],
        [8.741374723, 50.091395864],
        [8.741596473, 50.091678959],
        [8.742025041, 50.092226748],
        [8.742119479, 50.092284756],
        [8.74217422, 50.092318501],
        [8.742347215, 50.092424962],
        [8.742862449, 50.092738624],
        [8.743223451, 50.092797939],
        [8.743507883, 50.09284466],
        [8.743560242, 50.092853226],
        [8.743821302, 50.092896073],
        [8.743914871, 50.092944612],
        [8.744158616, 50.093071444],
        [8.744464785, 50.093230778],
        [8.74463619, 50.093319979],
        [8.744784321, 50.093397073],
        [8.744801293, 50.093406235],
        [8.744947774, 50.093457388],
        [8.745148848, 50.093528011],
        [8.745155532, 50.093530359],
        [8.745220548, 50.093553193],
        [8.74535531, 50.093600588],
        [8.745370933, 50.093606017],
        [8.745662429, 50.093708425],
        [8.745733676, 50.093731902],
        [8.745739843, 50.093733938],
        [8.745908131, 50.093789407],
        [8.746258014, 50.093904711],
        [8.746291236, 50.093915659],
        [8.746858021, 50.094102454],
        [8.747067265, 50.094117204],
        [8.747610768, 50.094155514],
        [8.747793878, 50.094161845],
        [8.748306885, 50.094179848],
        [8.748651601, 50.094191895],
        [8.748811213, 50.094197472],
        [8.74881145, 50.094197849],
        [8.74893734, 50.094398157],
        [8.748994297, 50.094487968],
        [8.749109249, 50.094669236],
        [8.749289319, 50.094954285],
        [8.749321547, 50.095005186],
        [8.749362716, 50.095279552],
        [8.749387903, 50.095448085],
        [8.749428022, 50.095636632],
        [8.749435537, 50.095671952],
        [8.749438869, 50.095687617],
        [8.7496098, 50.095865813],
        [8.749660897, 50.095919038],
        [8.749720073, 50.095980678],
        [8.750211076, 50.096491053],
        [8.75019864, 50.096508608],
        [8.74998834, 50.096805476],
        [8.749873445, 50.097018655],
        [8.749608766, 50.097604777],
        [8.749549791, 50.09773795],
        [8.749403561, 50.097863787],
        [8.74898074, 50.098230481],
        [8.748726663, 50.098471323],
        [8.748689427, 50.098506638],
        [8.748652519, 50.098540928],
        [8.748484539, 50.098673802],
        [8.748236112, 50.099038902],
        [8.748136638, 50.099143612],
        [8.748053538, 50.099229248],
        [8.747795809, 50.099428084],
        [8.74763309, 50.099540389],
        [8.747548924, 50.099598554],
        [8.74728508, 50.099749448],
        [8.746942831, 50.099898133],
        [8.746271551, 50.10010011],
        [8.746037748, 50.100225074],
        [8.7459988, 50.100245039],
        [8.745911844, 50.10026993],
        [8.745901206, 50.100272874],
        [8.745547095, 50.10037117],
        [8.745531082, 50.100402326],
        [8.745466028, 50.100524803],
        [8.745461861, 50.100532819],
        [8.745426569, 50.100600706],
        [8.745425766, 50.100602251],
        [8.745426382, 50.10060327],
        [8.745493594, 50.1007142],
        [8.745358214, 50.10081197],
        [8.745151514, 50.100961108],
        [8.745108936, 50.100991797],
        [8.745059878, 50.101027156],
        [8.74495758, 50.101100905],
        [8.744925294, 50.101124299],
        [8.744823557, 50.101197518],
        [8.744716332, 50.101274644],
        [8.744699651, 50.101336893],
        [8.744670864, 50.101441244],
        [8.744595905, 50.101712263],
        [8.744584033, 50.101754411],
        [8.744575171, 50.101785871],
        [8.744584869, 50.101792171],
        [8.744598091, 50.10180076],
        [8.744585563, 50.101823541],
        [8.74452432, 50.101934905],
        [8.744523007, 50.101937284],
        [8.744386285, 50.101991411],
        [8.744342581, 50.102035467],
        [8.743961023, 50.102269753],
        [8.743645509, 50.102463483],
        [8.743483129, 50.102563187],
        [8.743478453, 50.102564938],
        [8.743466411, 50.102569445],
        [8.743010874, 50.102739974],
        [8.742813093, 50.102816666],
        [8.742359602, 50.10299251],
        [8.742321923, 50.103031898],
        [8.742156795, 50.10320452],
        [8.742021741, 50.103504371],
        [8.741934713, 50.103697552],
        [8.74188687, 50.103908053],
        [8.741839226, 50.10411771],
        [8.741844726, 50.104186866],
        [8.74172326, 50.104287748],
        [8.740582639, 50.104229209],
        [8.740552357, 50.104245504],
        [8.740504903, 50.104595221],
        [8.740501948, 50.104616998],
        [8.739921561, 50.104592936],
        [8.739116903, 50.104559571],
        [8.73906008, 50.104557224],
        [8.739033961, 50.104721149],
        [8.738980982, 50.104718953],
        [8.738058094, 50.104685782],
        [8.738057569, 50.10469102],
        [8.738012847, 50.105137371],
        [8.737993792, 50.105327645],
        [8.737802745, 50.105319733],
        [8.735932328, 50.105242261],
        [8.733053493, 50.105122672],
        [8.733029165, 50.105121695],
        [8.733004831, 50.105120775],
        [8.732980489, 50.10511992],
        [8.732956144, 50.105119123],
        [8.732931795, 50.105118389],
        [8.732907441, 50.105117715],
        [8.732883082, 50.105117104],
        [8.732858721, 50.105116551],
        [8.732834356, 50.105116062],
        [8.732809989, 50.105115631],
        [8.732785618, 50.105115265],
        [8.732761247, 50.105114957],
        [8.732736873, 50.105114713],
        [8.732712499, 50.105114529],
        [8.732688124, 50.105114405],
        [8.732663749, 50.105114343],
        [8.732639371, 50.105114341],
        [8.732614995, 50.105114402],
        [8.732589584, 50.105114512],
        [8.732564173, 50.105114691],
        [8.732538764, 50.105114937],
        [8.732513358, 50.105115249],
        [8.732487952, 50.105115627],
        [8.732462551, 50.105116072],
        [8.732437152, 50.105116584],
        [8.732411755, 50.105117163],
        [8.732386365, 50.105117811],
        [8.732360976, 50.105118523],
        [8.732335592, 50.105119303],
        [8.732310216, 50.105120149],
        [8.732284843, 50.105121061],
        [8.732259479, 50.10512204],
        [8.732234119, 50.105123088],
        [8.732208767, 50.105124203],
        [8.732183421, 50.105125381],
        [8.732158081, 50.105126627],
        [8.732132754, 50.105127941],
        [8.732107432, 50.105129322],
        [8.73208212, 50.105130766],
        [8.73205682, 50.105132279],
        [8.732031527, 50.10513386],
        [8.732006244, 50.105135506],
        [8.73198097, 50.105137218],
        [8.731955709, 50.105138998],
        [8.731930463, 50.105140844],
        [8.731905224, 50.105142754],
        [8.731879999, 50.105144734],
        [8.731854787, 50.105146777],
        [8.731829588, 50.10514889],
        [8.731804404, 50.105151067],
        [8.731779233, 50.10515331],
        [8.731754077, 50.10515562],
        [8.731728933, 50.105157995],
        [8.731703808, 50.105160438],
        [8.731678697, 50.105162946],
        [8.731653604, 50.10516552],
        [8.731628526, 50.10516816],
        [8.731603464, 50.105170866],
        [8.731578421, 50.105173638],
        [8.731553395, 50.105176475],
        [8.731528385, 50.105179379],
        [8.731503398, 50.105182349],
        [8.73147843, 50.105185384],
        [8.731453478, 50.105188484],
        [8.731428547, 50.105191651],
        [8.73140364, 50.105194883],
        [8.731378748, 50.105198181],
        [8.731353881, 50.105201543],
        [8.731329034, 50.105204969],
        [8.731304211, 50.105208457],
        [8.731279407, 50.105212012],
        [8.731263588, 50.105214325],
        [8.731254628, 50.105215635],
        [8.731229874, 50.105219319],
        [8.731205142, 50.10522307],
        [8.731180432, 50.105226886],
        [8.731155749, 50.105230766],
        [8.73113109, 50.105234712],
        [8.731106456, 50.105238722],
        [8.731081849, 50.105242797],
        [8.731057269, 50.105246938],
        [8.731032713, 50.105251142],
        [8.731008184, 50.105255411],
        [8.730983683, 50.105259746],
        [8.730959208, 50.105264143],
        [8.730934767, 50.105268605],
        [8.730910349, 50.105273131],
        [8.73088596, 50.105277724],
        [8.730861604, 50.105282378],
        [8.730837274, 50.105287096],
        [8.730812975, 50.105291879],
        [8.73078871, 50.105296727],
        [8.730764472, 50.105301637],
        [8.730740267, 50.105306611],
        [8.730716095, 50.105311648],
        [8.730691954, 50.105316751],
        [8.730667845, 50.105321915],
        [8.730643771, 50.105327144],
        [8.730619728, 50.105332435],
        [8.73059572, 50.10533779],
        [8.730571747, 50.105343208],
        [8.730547808, 50.105348688],
        [8.730523905, 50.105354232],
        [8.730500038, 50.10535984],
        [8.730476202, 50.105365509],
        [8.730452407, 50.10537124],
        [8.730428648, 50.105377037],
        [8.730404925, 50.105382893],
        [8.73038124, 50.105388811],
        [8.730357593, 50.105394793],
        [8.730333984, 50.105400837],
        [8.730310413, 50.105406943],
        [8.730286881, 50.105413111],
        [8.73026339, 50.105419341],
        [8.730239937, 50.105425632],
        [8.730216525, 50.105431986],
        [8.730193153, 50.105438399],
        [8.730169822, 50.105444875],
        [8.730146534, 50.105451414],
        [8.730122372, 50.105458262],
        [8.730098257, 50.105465176],
        [8.730074186, 50.105472156],
        [8.73005016, 50.1054792],
        [8.73002618, 50.10548631],
        [8.73000225, 50.105493486],
        [8.729978365, 50.105500725],
        [8.729954527, 50.105508029],
        [8.729934272, 50.105514306],
        [8.729930738, 50.105515401],
        [8.729907, 50.105522834],
        [8.729883309, 50.105530333],
        [8.729859669, 50.105537897],
        [8.729836078, 50.105545524],
        [8.729812536, 50.105553214],
        [8.729789045, 50.105560969],
        [8.729765607, 50.105568788],
        [8.729742219, 50.105576671],
        [8.729718883, 50.105584618],
        [8.7296956, 50.105592626],
        [8.729672371, 50.105600699],
        [8.729649194, 50.105608834],
        [8.729626068, 50.105617033],
        [8.729602998, 50.105625294],
        [8.729579985, 50.105633618],
        [8.729557025, 50.105642005],
        [8.729534121, 50.105650454],
        [8.72951127, 50.105658963],
        [8.729488478, 50.105667538],
        [8.729465743, 50.105676171],
        [8.729447592, 50.105683131],
        [8.729443062, 50.105684868],
        [8.729420441, 50.105693626],
        [8.729397877, 50.105702447],
        [8.72937537, 50.105711327],
        [8.729352922, 50.105720269],
        [8.729330535, 50.105729272],
        [8.729308204, 50.105738334],
        [8.729285935, 50.105747458],
        [8.729263725, 50.105756643],
        [8.729243213, 50.105765201],
        [8.729222753, 50.105773811],
        [8.729202344, 50.105782473],
        [8.729181989, 50.105791186],
        [8.729161686, 50.105799949],
        [8.729141438, 50.105808764],
        [8.729121245, 50.105817631],
        [8.729101102, 50.105826547],
        [8.729081018, 50.105835514],
        [8.729060985, 50.105844531],
        [8.729041009, 50.105853599],
        [8.729021088, 50.105862718],
        [8.729001221, 50.105871886],
        [8.728981412, 50.105881104],
        [8.728961659, 50.105890372],
        [8.728941962, 50.10589969],
        [8.728922323, 50.105909058],
        [8.72890274, 50.105918473],
        [8.728882296, 50.105928385],
        [8.728861915, 50.105938349],
        [8.728841601, 50.105948368],
        [8.728821349, 50.10595844],
        [8.728801163, 50.105968566],
        [8.728781041, 50.105978743],
        [8.728771065, 50.105983831],
        [8.728760981, 50.105988976],
        [8.72874099, 50.105999259],
        [8.728721063, 50.106009597],
        [8.728701203, 50.106019986],
        [8.728681409, 50.106030427],
        [8.728661678, 50.106040921],
        [8.728642017, 50.106051465],
        [8.728622424, 50.106062063],
        [8.728602898, 50.106072712],
        [8.728583441, 50.106083412],
        [8.72856405, 50.106094162],
        [8.72854473, 50.106104965],
        [8.728525478, 50.106115818],
        [8.728506297, 50.106126722],
        [8.728487181, 50.106137676],
        [8.728468138, 50.106148679],
        [8.728449166, 50.106159734],
        [8.728430264, 50.106170837],
        [8.728411433, 50.106181992],
        [8.728392671, 50.106193196],
        [8.728388628, 50.106195631],
        [8.728373983, 50.106204449],
        [8.728355366, 50.10621575],
        [8.728336823, 50.106227101],
        [8.728318351, 50.1062385],
        [8.728299952, 50.106249949],
        [8.728281625, 50.106261446],
        [8.728263371, 50.10627299],
        [8.728245192, 50.106284583],
        [8.728227088, 50.106296224],
        [8.728209056, 50.106307913],
        [8.728191101, 50.106319649],
        [8.728173217, 50.10633143],
        [8.728155411, 50.106343259],
        [8.72813768, 50.106355138],
        [8.728120024, 50.106367061],
        [8.728102447, 50.106379031],
        [8.728084944, 50.106391045],
        [8.728067517, 50.106403108],
        [8.728050001, 50.106415333],
        [8.728032562, 50.106427605],
        [8.728015202, 50.106439923],
        [8.728012107, 50.106442137],
        [8.727997921, 50.106452288],
        [8.727980722, 50.106464697],
        [8.7279636, 50.106477153],
        [8.727946562, 50.106489655],
        [8.727929602, 50.106502201],
        [8.727912723, 50.106514792],
        [8.727895925, 50.10652743],
        [8.72787921, 50.106540111],
        [8.727862575, 50.106552836],
        [8.727846022, 50.106565604],
        [8.727829553, 50.106578419],
        [8.727813164, 50.106591274],
        [8.727796858, 50.106604175],
        [8.727780637, 50.106617119],
        [8.727764499, 50.106630106],
        [8.727748443, 50.106643135],
        [8.727732471, 50.106656208],
        [8.727716586, 50.106669322],
        [8.727700783, 50.106682479],
        [8.727618367, 50.106664637],
        [8.727508322, 50.106638236],
        [8.727506277, 50.106641576],
        [8.727354252, 50.106889047],
        [8.727165501, 50.107197395],
        [8.727154686, 50.107215062],
        [8.727136362, 50.107209674],
        [8.726794643, 50.107109193],
        [8.726579267, 50.107429318],
        [8.726531855, 50.107499789],
        [8.726477424, 50.107580249],
        [8.726409355, 50.107680964],
        [8.726405638, 50.107686554],
        [8.726283011, 50.107740999],
        [8.726359884, 50.107767791],
        [8.726354563, 50.107772326],
        [8.726243014, 50.107868161],
        [8.726114709, 50.10797842],
        [8.726089547, 50.108000058],
        [8.726083268, 50.108005456],
        [8.725783994, 50.108263651],
        [8.725639265, 50.108388515],
        [8.72563563, 50.10839165],
        [8.725518203, 50.108492245],
        [8.72552472, 50.10849417],
        [8.726153901, 50.108680125],
        [8.726165288, 50.108683473],
        [8.726183125, 50.108688734],
        [8.72619142, 50.108691181],
        [8.726243396, 50.108706502],
        [8.726301284, 50.108723571],
        [8.726799652, 50.108870341],
        [8.727509802, 50.109079478],
        [8.727642263, 50.109118487],
        [8.72766103, 50.109123019],
        [8.728637833, 50.109358894],
        [8.729686296, 50.109661297],
        [8.729949619, 50.109741637],
        [8.731053429, 50.110078399],
        [8.732385839, 50.110484884],
        [8.734161853, 50.11101097],
        [8.735134694, 50.111271139],
        [8.735170166, 50.111280561],
        [8.735354793, 50.111329654],
        [8.73539507, 50.111340336],
        [8.735539865, 50.111378569],
        [8.735563647, 50.111385824],
        [8.735598344, 50.111396413],
        [8.736098474, 50.111543781],
        [8.736148331, 50.111558471],
        [8.736591132, 50.111785802],
        [8.736999089, 50.111995241],
        [8.737392835, 50.112221387],
        [8.737673395, 50.112382523],
        [8.738099931, 50.112627496],
        [8.738399529, 50.112808606],
        [8.738585204, 50.112921582],
        [8.738978956, 50.113159091],
        [8.739458795, 50.113390014],
        [8.74028023, 50.11378532],
        [8.741323679, 50.114272006],
        [8.74167426, 50.114386878],
        [8.743335321, 50.114931118],
        [8.7441662, 50.115151655],
        [8.745644428, 50.115392672],
        [8.745645728, 50.115392807],
        [8.746901547, 50.115523282],
        [8.748484828, 50.115630598],
        [8.750214643, 50.115587171],
        [8.752103848, 50.115436927],
        [8.75296424, 50.115321488],
        [8.754330915, 50.114982128],
        [8.754384324, 50.114958361],
        [8.754878433, 50.114738476],
        [8.755795731, 50.11427573],
        [8.755870869, 50.114237825],
        [8.757072318, 50.113431507],
        [8.758271568, 50.112414538],
        [8.758333549, 50.112368938],
        [8.760572609, 50.110730581],
        [8.762123847, 50.109836448],
        [8.762140482, 50.109829987],
        [8.762842235, 50.109557453],
        [8.76284229, 50.109557432],
        [8.763217756, 50.109411612],
        [8.765779568, 50.108618456],
        [8.767489003, 50.108186121],
        [8.767667133, 50.108141068],
        [8.767889867, 50.108103131],
        [8.768893754, 50.107932139],
        [8.770343822, 50.107843272],
        [8.77034787, 50.107843365],
        [8.771689618, 50.107874051],
        [8.77264503, 50.107982502],
        [8.772898211, 50.108027783],
        [8.773424135, 50.108121843],
        [8.773599209, 50.108172889],
        [8.774919977, 50.108557062],
        [8.776060329, 50.109014263],
        [8.776730003, 50.109282651],
        [8.778266783, 50.110019531],
        [8.779166674, 50.11053209],
        [8.77980945, 50.111053173],
        [8.779822718, 50.111068275],
        [8.780374125, 50.111695897],
        [8.780592064, 50.112063635],
        [8.780734794, 50.112461194],
        [8.78082035, 50.1126995],
        [8.780856505, 50.112825324],
        [8.780947199, 50.113140947],
        [8.780888041, 50.114588914],
        [8.780829561, 50.114816887],
        [8.780746271, 50.11514157],
        [8.780626949, 50.115461145],
        [8.78052732, 50.115727972],
        [8.779764571, 50.117198586],
        [8.779014198, 50.118149795],
        [8.778644277, 50.118449908],
        [8.776516957, 50.119943418],
        [8.776178479, 50.120181038],
        [8.776002489, 50.120304587],
        [8.774860178, 50.121329839],
        [8.773257603, 50.122893342],
        [8.772320617, 50.124220918],
        [8.771544476, 50.124943404],
        [8.771328934, 50.125178896],
        [8.771225265, 50.125292157],
        [8.771214575, 50.12530383],
        [8.771184499, 50.125336669],
        [8.771124724, 50.125401952],
        [8.770710932, 50.125853866],
        [8.770442944, 50.126195813],
        [8.770010711, 50.126747324],
        [8.769746598, 50.127176212],
        [8.769720116, 50.127219216],
        [8.769646468, 50.127377126],
        [8.769361834, 50.127987409],
        [8.769266007, 50.128246982],
        [8.769011965, 50.128935111],
        [8.768925956, 50.129685926],
        [8.768949593, 50.130109101],
        [8.768977006, 50.130599836],
        [8.769011533, 50.130821175],
        [8.76908665, 50.131302716],
        [8.769107489, 50.131366603],
        [8.769308576, 50.131983046],
        [8.769490033, 50.132309187],
        [8.769739948, 50.13275836],
        [8.770451817, 50.13354264],
        [8.770655612, 50.13376716],
        [8.770849746, 50.133921446],
        [8.771691826, 50.134590666],
        [8.773070874, 50.135464224],
        [8.773640947, 50.135747601],
        [8.774482428, 50.136083277],
        [8.775292888, 50.136334567],
        [8.777351771, 50.136909065],
        [8.778639544, 50.137139658],
        [8.778733929, 50.13715232],
        [8.779773965, 50.137291831],
        [8.779872277, 50.137858898],
        [8.77988964, 50.137959028],
        [8.77989986, 50.138017943],
        [8.779909155, 50.138071579],
        [8.779910844, 50.138081327],
        [8.779919669, 50.138130719],
        [8.779921074, 50.138138615],
        [8.779925425, 50.138165954],
        [8.77994233, 50.138266997],
        [8.77995335, 50.138332866],
        [8.783216424, 50.139012829],
        [8.784054223, 50.139187393],
        [8.78417364, 50.139213717],
        [8.784177198, 50.139214502],
        [8.784498173, 50.139286659],
        [8.784671889, 50.139322222],
        [8.784910926, 50.139371203],
        [8.784912255, 50.139371475],
        [8.784903185, 50.13939744],
        [8.784759666, 50.139806601],
        [8.784740253, 50.139862124],
        [8.784721268, 50.139915941],
        [8.784712766, 50.139940109],
        [8.784673941, 50.140051067],
        [8.78467254, 50.14005353],
        [8.784591449, 50.140196114],
        [8.784575667, 50.140223858],
        [8.784389562, 50.140551568],
        [8.784164045, 50.140711806],
        [8.783592781, 50.141110902],
        [8.783586737, 50.141117095],
        [8.783577023, 50.141130832],
        [8.783212742, 50.141539661],
        [8.783208869, 50.141545109],
        [8.783159752, 50.141614202],
        [8.782839805, 50.142064267],
        [8.782802281, 50.142102586],
        [8.782762058, 50.142150159],
        [8.782742367, 50.142173407],
        [8.782706484, 50.142220089],
        [8.782664006, 50.14227094],
        [8.782597759, 50.142350245],
        [8.782526875, 50.142433722],
        [8.782510703, 50.142452752],
        [8.782463855, 50.142507855],
        [8.782447991, 50.142690318],
        [8.782434931, 50.142840531],
        [8.782428422, 50.142915678],
        [8.782425624, 50.142946599],
        [8.782403855, 50.143201592],
        [8.782388529, 50.14338111],
        [8.782379724, 50.143476935],
        [8.78236896, 50.143594169],
        [8.782349547, 50.143806118],
        [8.782343528, 50.143871837],
        [8.782333477, 50.143981584],
        [8.782330417, 50.14401468],
        [8.782322806, 50.144083557],
        [8.782268829, 50.144572035],
        [8.782259836, 50.144673338],
        [8.782311223, 50.145909148],
        [8.782311226, 50.14590922],
        [8.782413535, 50.148369474],
        [8.782465978, 50.14955874],
        [8.782489317, 50.149879871],
        [8.782518801, 50.150285557],
        [8.782546154, 50.150661904],
        [8.782571444, 50.150882025],
        [8.782608172, 50.151201687],
        [8.782617924, 50.151229414],
        [8.782613796, 50.151313105],
        [8.782608595, 50.151420511],
        [8.782605109, 50.151464583],
        [8.782617021, 50.151512677],
        [8.782614686, 50.151568061],
        [8.782620449, 50.15160557],
        [8.782622373, 50.15164443],
        [8.782624615, 50.151689799],
        [8.782627192, 50.151742064],
        [8.782631075, 50.151820682],
        [8.782640452, 50.151900604],
        [8.782644958, 50.151971582],
        [8.782648809, 50.152033047],
        [8.782654449, 50.152122421],
        [8.782649942, 50.152166068],
        [8.78265956, 50.152202047],
        [8.782669763, 50.152297291],
        [8.782675884, 50.152329883],
        [8.782681382, 50.152379754],
        [8.782673886, 50.152412851],
        [8.782687305, 50.152514915],
        [8.78269326, 50.152553405],
        [8.782696185, 50.152584175],
        [8.782718674, 50.152731719],
        [8.782725423, 50.152786564],
        [8.782730282, 50.15282604],
        [8.782733118, 50.152848701],
        [8.782734277, 50.152917523],
        [8.782647954, 50.153363809],
        [8.782629077, 50.153423109],
        [8.782538149, 50.153755013],
        [8.782415231, 50.15410907],
        [8.782418001, 50.15413681],
        [8.78242179, 50.154174702],
        [8.78242354, 50.154221095],
        [8.782425165, 50.154263892],
        [8.782425903, 50.154284215],
        [8.782426603, 50.154303413],
        [8.782428027, 50.154342463],
        [8.782438737, 50.154542417],
        [8.782434509, 50.154579898],
        [8.782424598, 50.154667176],
        [8.782419505, 50.154710079],
        [8.782400435, 50.154870751],
        [8.782386725, 50.154999699],
        [8.78238097, 50.155057403],
        [8.782379954, 50.155067599],
        [8.782329326, 50.155308974],
        [8.782273968, 50.155451545],
        [8.782241485, 50.155534485],
        [8.782239934, 50.155538445],
        [8.782608088, 50.155613634],
        [8.782700643, 50.15563097],
        [8.78298628, 50.155684245],
        [8.782990337, 50.155685002],
        [8.783176042, 50.155712319],
        [8.783385372, 50.155755584],
        [8.783522778, 50.155777514],
        [8.783561716, 50.155781962],
        [8.783602777, 50.155786652],
        [8.783694942, 50.155797883],
        [8.784070769, 50.155847285],
        [8.78407961, 50.155848447],
        [8.783894053, 50.156295314],
        [8.783688724, 50.156772235],
        [8.783665345, 50.156767512],
        [8.783661322, 50.1567667],
        [8.783659712, 50.15677021],
        [8.783617022, 50.156863266],
        [8.783586351, 50.156930121],
        [8.783548166, 50.157013336],
        [8.783454878, 50.157216684],
        [8.783406779, 50.157640027],
        [8.783395093, 50.157742899],
        [8.783398746, 50.15774744],
        [8.783455125, 50.157817522],
        [8.78343693, 50.158330752],
        [8.783433833, 50.158418473],
        [8.783432534, 50.158454996],
        [8.783432391, 50.158459016],
        [8.783560436, 50.158470936],
        [8.783769405, 50.158490389],
        [8.7837961, 50.158498081],
        [8.784062961, 50.158574598],
        [8.784088336, 50.158581873],
        [8.784177092, 50.158593191],
        [8.784413777, 50.158623372],
        [8.784454184, 50.158635196],
        [8.784502521, 50.158649339],
        [8.784841151, 50.158717212],
        [8.784949985, 50.15873912],
        [8.785014646, 50.158752136],
        [8.785057151, 50.158760486],
        [8.785242012, 50.15879811],
        [8.785672813, 50.158814807],
        [8.785942989, 50.158825904],
        [8.786051865, 50.158845661],
        [8.786078621, 50.158850516],
        [8.786232426, 50.158917037],
        [8.786329751, 50.15895913],
        [8.786533461, 50.159063602],
        [8.786579872, 50.159088946],
        [8.786636208, 50.15911971],
        [8.786767447, 50.159185578],
        [8.786874276, 50.159236479],
        [8.786918246, 50.159261732],
        [8.786937019, 50.159272591],
        [8.786972435, 50.159286375],
        [8.786985263, 50.159301642],
        [8.787015032, 50.159337068],
        [8.787166629, 50.159431484],
        [8.787224724, 50.159420693],
        [8.787477798, 50.159373685],
        [8.78796645, 50.159247389],
        [8.788023913, 50.159232536],
        [8.788570429, 50.159104752],
        [8.789131146, 50.15897364],
        [8.789447753, 50.158895898],
        [8.789552291, 50.158895188],
        [8.789553164, 50.158895394],
        [8.789755694, 50.158943204],
        [8.789850477, 50.158965581],
        [8.790077482, 50.158954494],
        [8.790146934, 50.158951102],
        [8.790394196, 50.158928568],
        [8.790524923, 50.158916657],
        [8.790628801, 50.158907189],
        [8.790679987, 50.158946568],
        [8.790652776, 50.159279338],
        [8.790629725, 50.159556716],
        [8.790615303, 50.159633136],
        [8.790578651, 50.159827345],
        [8.790578024, 50.159830675],
        [8.790578519, 50.159857635],
        [8.790579709, 50.159922289],
        [8.79059586, 50.159973472],
        [8.790960416, 50.161124609],
        [8.790832123, 50.16115135],
        [8.790738715, 50.161172327],
        [8.790291214, 50.161272815],
        [8.789830237, 50.161376334],
        [8.789794903, 50.161384268],
        [8.789645394, 50.16141784],
        [8.789526392, 50.161444425],
        [8.789544158, 50.161478081],
        [8.789568448, 50.161524011],
        [8.789776055, 50.161916855],
        [8.789955826, 50.162257019],
        [8.790322107, 50.162952445],
        [8.790360548, 50.163088267],
        [8.790445172, 50.163387704],
        [8.790453856, 50.163418287],
        [8.790467819, 50.163467307],
        [8.790869584, 50.163447214],
        [8.791536823, 50.163413838],
        [8.791905488, 50.16337521],
        [8.791928485, 50.163371239],
        [8.792114174, 50.163339172],
        [8.792591684, 50.163273854],
        [8.793408822, 50.163176528],
        [8.793460259, 50.163170401],
        [8.793589077, 50.16314379],
        [8.793985855, 50.163061822],
        [8.794010653, 50.163093819],
        [8.794602465, 50.163857418],
        [8.794647912, 50.163914285],
        [8.794843557, 50.163862134],
        [8.794897862, 50.163847659],
        [8.794901189, 50.163848242],
        [8.794984848, 50.163862916],
        [8.795037062, 50.163940853],
        [8.795037973, 50.163942212],
        [8.794959202, 50.16412928],
        [8.794823486, 50.164451581],
        [8.794824205, 50.164455984],
        [8.794849127, 50.164608685],
        [8.794847148, 50.164618192],
        [8.794804118, 50.16482483],
        [8.794611898, 50.165784828],
        [8.794464073, 50.166527032],
        [8.794410593, 50.166795534],
        [8.794402543, 50.166836777],
        [8.794401893, 50.166840109],
        [8.794447149, 50.166858259],
        [8.795448954, 50.167259387],
        [8.79551627, 50.167263756],
        [8.795530251, 50.167264667],
        [8.795602172, 50.167269378],
        [8.796645699, 50.167337838],
        [8.796771205, 50.167345967],
        [8.79781854, 50.167413797],
        [8.797818731, 50.16741458],
        [8.797868005, 50.167615847],
        [8.798098151, 50.16855587],
        [8.79815576, 50.169197249],
        [8.798178542, 50.169450898],
        [8.798187097, 50.1694505],
        [8.798234402, 50.169448298],
        [8.800138143, 50.169359052],
        [8.80016983, 50.169605646],
        [8.800152143, 50.169880498],
        [8.800128987, 50.170240308],
        [8.800112651, 50.170494159],
        [8.800014858, 50.170996779],
        [8.800005956, 50.171050336],
        [8.799995632, 50.17111262],
        [8.800372943, 50.17123282],
        [8.800404881, 50.171244158],
        [8.799275912, 50.172786702],
        [8.799274106, 50.172789169],
        [8.799591107, 50.173064302],
        [8.799646664, 50.173112521],
        [8.798168295, 50.173726059],
        [8.79812188, 50.173745308],
        [8.798077736, 50.173766356],
        [8.798031142, 50.173788573],
        [8.796949714, 50.174304321],
        [8.796903425, 50.174326356],
        [8.796679203, 50.174396608],
        [8.796640898, 50.174408608],
        [8.796609919, 50.174418533],
        [8.796385799, 50.174488885],
        [8.796318084, 50.174512681],
        [8.796282652, 50.174483491],
        [8.795314377, 50.173689674],
        [8.793984576, 50.172569486],
        [8.793377619, 50.173190363],
        [8.793291338, 50.173276815],
        [8.792997359, 50.173571377],
        [8.792878648, 50.173669878],
        [8.792562287, 50.17393218],
        [8.79244259, 50.174031489],
        [8.792326983, 50.174127388],
        [8.792299413, 50.174119242],
        [8.79224953, 50.174104504],
        [8.791421597, 50.174766934],
        [8.790684377, 50.17535661],
        [8.790376756, 50.175602658],
        [8.790221256, 50.175813432],
        [8.79007137, 50.176016592],
        [8.790004922, 50.176106726],
        [8.789973963, 50.176175199],
        [8.789971918, 50.176179721],
        [8.789970825, 50.176179788],
        [8.789453069, 50.176211876],
        [8.788005049, 50.176303698],
        [8.787693378, 50.176323459],
        [8.787631134, 50.176327418],
        [8.787490403, 50.176336331],
        [8.787149849, 50.176357906],
        [8.786413127, 50.176429614],
        [8.785259686, 50.176541872],
        [8.785100306, 50.1765574],
        [8.785034901, 50.176563753],
        [8.784883954, 50.176578442],
        [8.784853757, 50.176581381],
        [8.784794864, 50.17658626],
        [8.783377449, 50.176703697],
        [8.783321711, 50.176708357],
        [8.78328635, 50.176711322],
        [8.782944384, 50.17690481],
        [8.782913226, 50.176922463],
        [8.782729489, 50.177026481],
        [8.782607256, 50.177095681],
        [8.782605791, 50.177095687],
        [8.782550978, 50.177095918],
        [8.78250674, 50.177096105],
        [8.780869469, 50.177102728],
        [8.780812619, 50.17710235],
        [8.779189499, 50.177109703],
        [8.77913294, 50.177109956],
        [8.779132894, 50.177111406],
        [8.779100969, 50.178125879],
        [8.779098386, 50.17820675],
        [8.779093712, 50.178206816],
        [8.778231167, 50.178219165],
        [8.777710882, 50.178226611],
        [8.777644582, 50.178274222],
        [8.777649204, 50.178367495],
        [8.777664438, 50.178675422],
        [8.777784153, 50.178808111],
        [8.777945912, 50.179037923],
        [8.777977802, 50.17908323],
        [8.778054524, 50.179240112],
        [8.778126269, 50.179386815],
        [8.778308983, 50.17975052],
        [8.778415303, 50.179962146],
        [8.778608892, 50.180314773],
        [8.778630861, 50.18035479],
        [8.778688286, 50.180383154],
        [8.778640683, 50.180377478],
        [8.778562939, 50.180368209],
        [8.778505877, 50.180361402],
        [8.778375174, 50.180354581],
        [8.777038842, 50.180195025],
        [8.776981768, 50.18018821],
        [8.776960843, 50.180187163],
        [8.776636195, 50.180170969],
        [8.776438235, 50.180161096],
        [8.776238176, 50.180151119],
        [8.776066726, 50.180142563],
        [8.775775295, 50.180128022],
        [8.775503669, 50.180114481],
        [8.775377138, 50.180108169],
        [8.775356071, 50.180107121],
        [8.775298893, 50.18010429],
        [8.773284393, 50.18000451],
        [8.773158701, 50.179998287],
        [8.773088898, 50.179994798],
        [8.771105722, 50.179895656],
        [8.771063284, 50.179893532],
        [8.770901057, 50.179898158],
        [8.769230934, 50.179816022],
        [8.768856001, 50.179797579],
        [8.768786241, 50.179794078],
        [8.768664416, 50.179772736],
        [8.76861235, 50.179763616],
        [8.767469873, 50.179563492],
        [8.767402338, 50.179551661],
        [8.76726477, 50.179534979],
        [8.765121034, 50.179274993],
        [8.764940541, 50.179253096],
        [8.764423157, 50.179190333],
        [8.762688423, 50.178979909],
        [8.762688791, 50.178975902],
        [8.762697907, 50.178876801],
        [8.762736948, 50.178452733],
        [8.762803296, 50.177731567],
        [8.762813062, 50.177625411],
        [8.762852193, 50.177200074],
        [8.76288518, 50.176841692],
        [8.762888508, 50.176805531],
        [8.762867759, 50.1768061],
        [8.762729207, 50.176809923],
        [8.762696034, 50.176810838],
        [8.762673498, 50.176266781],
        [8.762668556, 50.176147467],
        [8.76266773, 50.176127696],
        [8.762666569, 50.176090842],
        [8.762666505, 50.176088834],
        [8.762666168, 50.176078309],
        [8.762665916, 50.176072591],
        [8.762658928, 50.175916124],
        [8.762636927, 50.175423411],
        [8.762639982, 50.175190805],
        [8.762627859, 50.174073158],
        [8.762620446, 50.173671374],
        [8.762977802, 50.172893127],
        [8.76297233, 50.172836128],
        [8.762969041, 50.17280194],
        [8.762405106, 50.172777955],
        [8.762364282, 50.172776217],
        [8.761988077, 50.172760211],
        [8.761880447, 50.172757348],
        [8.761825159, 50.172753287],
        [8.760221533, 50.172636305],
        [8.760137799, 50.172630199],
        [8.760096212, 50.172627165],
        [8.760075069, 50.172625621],
        [8.757941358, 50.17196739],
        [8.757980894, 50.171880419],
        [8.75793922, 50.171849991],
        [8.757663429, 50.171648665],
        [8.756663805, 50.171322789],
        [8.756613762, 50.171306483],
        [8.75641911, 50.171243028],
        [8.755346364, 50.170900911],
        [8.755274689, 50.170878052],
        [8.755085471, 50.17081768],
        [8.754263503, 50.17051963],
        [8.753926671, 50.170311693],
        [8.753871645, 50.17028466],
        [8.753034798, 50.169873552],
        [8.752900722, 50.169807684],
        [8.752732224, 50.169737692],
        [8.752009873, 50.169437631],
        [8.751955681, 50.16941504],
        [8.751896181, 50.16939037],
        [8.751318377, 50.169063781],
        [8.750300909, 50.168688778],
        [8.74960533, 50.168407139],
        [8.749877405, 50.168142882],
        [8.748815139, 50.167344681],
        [8.748226823, 50.167085741],
        [8.747923715, 50.166968571],
        [8.746584717, 50.166425215],
        [8.746184839, 50.16622228],
        [8.746162756, 50.166211074],
        [8.745993803, 50.166141419],
        [8.74536741, 50.165883172],
        [8.744644044, 50.165475386],
        [8.744345808, 50.165307257],
        [8.74333221, 50.164471354],
        [8.743190538, 50.164400319],
        [8.742562124, 50.16408523],
        [8.742109724, 50.163969065],
        [8.74202153, 50.163947202],
        [8.741810741, 50.163893295],
        [8.741274358, 50.163756119],
        [8.740811224, 50.163682538],
        [8.740614617, 50.163651353],
        [8.740568949, 50.163637248],
        [8.740477411, 50.163608974],
        [8.740254417, 50.163539971],
        [8.739869487, 50.16342089],
        [8.739650711, 50.163206056],
        [8.739636139, 50.163191747],
        [8.739425494, 50.163138009],
        [8.739043167, 50.16304047],
        [8.738670677, 50.162900287],
        [8.73847708, 50.162754031],
        [8.738443211, 50.162728333],
        [8.738371579, 50.162672622],
        [8.738354666, 50.16266809],
        [8.738315401, 50.162657571],
        [8.738277394, 50.162646608],
        [8.738137803, 50.162606107],
        [8.738071294, 50.162586269],
        [8.737990459, 50.162575928],
        [8.737733846, 50.16253957],
        [8.737501153, 50.162508299],
        [8.737237824, 50.162471834],
        [8.737008873, 50.162440618],
        [8.736993092, 50.162438466],
        [8.736778674, 50.162696361],
        [8.736700142, 50.162790838],
        [8.736638229, 50.162865321],
        [8.736567243, 50.162845382],
        [8.736551763, 50.16286609],
        [8.736460374, 50.162988354],
        [8.736419357, 50.16304324],
        [8.736417514, 50.163045705],
        [8.736340497, 50.163031031],
        [8.736048846, 50.162975464],
        [8.736002052, 50.162966593],
        [8.735918655, 50.162950792],
        [8.735776978, 50.162923946],
        [8.735725948, 50.1629143],
        [8.735659121, 50.162901562],
        [8.735614662, 50.1628931],
        [8.735548254, 50.162880453],
        [8.735434732, 50.162858798],
        [8.735387059, 50.162849699],
        [8.735276319, 50.162828689],
        [8.735206556, 50.162815404],
        [8.735167131, 50.162807853],
        [8.735139207, 50.162795922],
        [8.735074422, 50.162768175],
        [8.73502681, 50.162747839],
        [8.734976545, 50.162726327],
        [8.734919441, 50.162701923],
        [8.734855913, 50.162674718],
        [8.734850417, 50.162672944],
        [8.73482001, 50.162663129],
        [8.734745548, 50.162639045],
        [8.734382238, 50.162521823],
        [8.734355764, 50.162513281],
        [8.734270548, 50.162485667],
        [8.734187145, 50.162458775],
        [8.734009431, 50.162401461],
        [8.733922117, 50.162373221],
        [8.733833827, 50.1623447],
        [8.733698597, 50.162301058],
        [8.733307585, 50.162243703],
        [8.733090839, 50.16221192],
        [8.732992812, 50.162197581],
        [8.732978397, 50.162197907],
        [8.732188798, 50.162214718],
        [8.731195176, 50.162235867],
        [8.731035025, 50.162239264],
        [8.730801391, 50.162244243],
        [8.730732066, 50.16224572],
        [8.730719024, 50.162250544],
        [8.730633323, 50.162282351],
        [8.730588304, 50.162298968],
        [8.730532908, 50.162319518],
        [8.730488438, 50.162336055],
        [8.730418316, 50.162362055],
        [8.730349443, 50.162387607],
        [8.730269926, 50.162417],
        [8.73018801, 50.162447377],
        [8.730127143, 50.162469991],
        [8.730061636, 50.162494202],
        [8.730004837, 50.162515288],
        [8.729953649, 50.162534318],
        [8.729903848, 50.162552723],
        [8.729856306, 50.162570323],
        [8.729790377, 50.162594812],
        [8.729714365, 50.162622954],
        [8.729620247, 50.162657888],
        [8.729548722, 50.162684342],
        [8.729473678, 50.162712126],
        [8.729380262, 50.162746791],
        [8.729324163, 50.162767609],
        [8.729274081, 50.162786201],
        [8.729262254, 50.162790558],
        [8.729259776, 50.162791471],
        [8.729251623, 50.162797835],
        [8.729207147, 50.162832497],
        [8.729191319, 50.162844804],
        [8.729098679, 50.162836525],
        [8.72905394, 50.162832528],
        [8.728733344, 50.162868829],
        [8.727749233, 50.162980346],
        [8.727707716, 50.162985051],
        [8.727436467, 50.163015765],
        [8.727301397, 50.163031046],
        [8.727171801, 50.163048265],
        [8.727103199, 50.163057382],
        [8.726914625, 50.163082382],
        [8.726702451, 50.163110544],
        [8.72648075, 50.163139988],
        [8.726262694, 50.163168936],
        [8.726051106, 50.163197036],
        [8.726038697, 50.163198689],
        [8.726008934, 50.163202646],
        [8.725862789, 50.163205979],
        [8.725816405, 50.163206813],
        [8.725604013, 50.16321141],
        [8.72549059, 50.163213863],
        [8.725173071, 50.163220732],
        [8.724994819, 50.163224581],
        [8.724965732, 50.163230347],
        [8.724764081, 50.163270336],
        [8.724743059, 50.163274505],
        [8.724562991, 50.163310216],
        [8.724534297, 50.163315902],
        [8.724363605, 50.163333704],
        [8.724189174, 50.163351891],
        [8.724056264, 50.163365745],
        [8.724032962, 50.163368378],
        [8.723798777, 50.163392707],
        [8.723792475, 50.163393456],
        [8.72378739, 50.163394073],
        [8.72375832, 50.163397034],
        [8.723702835, 50.163402854],
        [8.72365878, 50.163407475],
        [8.723440796, 50.163430343],
        [8.723327715, 50.163442113],
        [8.723321764, 50.163442738],
        [8.723213318, 50.163454104],
        [8.723066907, 50.163469461],
        [8.723023987, 50.163474059],
        [8.723007475, 50.163475829],
        [8.722979877, 50.163514286],
        [8.722959967, 50.163542441],
        [8.722846541, 50.163701514],
        [8.72283686, 50.163715101],
        [8.722763058, 50.163817784],
        [8.722494004, 50.16419252],
        [8.722322641, 50.16443119],
        [8.722183419, 50.164543675],
        [8.721913425, 50.164761844],
        [8.721837986, 50.164822689],
        [8.721484798, 50.165107986],
        [8.721147172, 50.165380758],
        [8.721061366, 50.165450093],
        [8.720873394, 50.165634256],
        [8.720591952, 50.165909968],
        [8.720473486, 50.166026125],
        [8.720358777, 50.166138397],
        [8.720306692, 50.166189616],
        [8.72022771, 50.166266787],
        [8.720183045, 50.166310533],
        [8.719987688, 50.166502319],
        [8.719916833, 50.166611263],
        [8.719874225, 50.166676475],
        [8.719527874, 50.167205632],
        [8.7192229, 50.167673308],
        [8.719008705, 50.168001768],
        [8.718746179, 50.168403689],
        [8.718740064, 50.16841306],
        [8.718707904, 50.168462303],
        [8.718667836, 50.168523655],
        [8.718665567, 50.168525779],
        [8.717939054, 50.16920629],
        [8.717858581, 50.16928537],
        [8.717496447, 50.169407996],
        [8.716733332, 50.169666395],
        [8.716572235, 50.169707452],
        [8.716550799, 50.169712915],
        [8.716104854, 50.169830876],
        [8.715366219, 50.170026255],
        [8.715117279, 50.170091778],
        [8.715004789, 50.170121368],
        [8.714586621, 50.170231364],
        [8.714554995, 50.170284915],
        [8.714271841, 50.17076435],
        [8.714227018, 50.170840118],
        [8.714223606, 50.170848965],
        [8.714121764, 50.171112483],
        [8.714109489, 50.171144247],
        [8.714044247, 50.171313373],
        [8.714019881, 50.171338485],
        [8.713971712, 50.171388353],
        [8.713922993, 50.171438767],
        [8.713874121, 50.171489262],
        [8.713824542, 50.171540574],
        [8.713800881, 50.17156498],
        [8.71377498, 50.171591696],
        [8.71372457, 50.171641654],
        [8.713668038, 50.171661746],
        [8.713602435, 50.171684134],
        [8.713520761, 50.171712007],
        [8.713432114, 50.171742274],
        [8.713342486, 50.171772809],
        [8.713251456, 50.17180388],
        [8.713159863, 50.171835129],
        [8.713070219, 50.171865753],
        [8.713053387, 50.171871475],
        [8.712994269, 50.171902884],
        [8.712921387, 50.171941741],
        [8.712847243, 50.171981124],
        [8.71277491, 50.172019612],
        [8.712700905, 50.172058996],
        [8.712581541, 50.172122549],
        [8.71255321, 50.172137611],
        [8.712463009, 50.172185566],
        [8.712389144, 50.17222486],
        [8.71231709, 50.172263267],
        [8.712244628, 50.172301845],
        [8.712160794, 50.172346417],
        [8.712149252, 50.172357088],
        [8.711990033, 50.17250487],
        [8.71192329, 50.172566761],
        [8.711891215, 50.172596503],
        [8.711886946, 50.172603831],
        [8.711642319, 50.173022699],
        [8.711584483, 50.17312206],
        [8.711550539, 50.173180134],
        [8.711517172, 50.173237579],
        [8.711516748, 50.173238118],
        [8.71147135, 50.173292207],
        [8.711426103, 50.173346207],
        [8.711381691, 50.17339922],
        [8.711337277, 50.173452143],
        [8.711259462, 50.17354508],
        [8.710951257, 50.173912887],
        [8.710835635, 50.174002672],
        [8.710805432, 50.174026104],
        [8.710805256, 50.174026241],
        [8.710761383, 50.174012384],
        [8.710689866, 50.17410318],
        [8.710462889, 50.174391298],
        [8.710071567, 50.174888041],
        [8.709829312, 50.175195772],
        [8.709493443, 50.175622412],
        [8.709398444, 50.175743057],
        [8.70919342, 50.176003414],
        [8.709143055, 50.176067307],
        [8.709143903, 50.176067846],
        [8.709181103, 50.176091478],
        [8.709265239, 50.176144929],
        [8.709279162, 50.176153774],
        [8.709212105, 50.176364427],
        [8.709198276, 50.176407887],
        [8.709184853, 50.176450003],
        [8.709180666, 50.176463141],
        [8.709164297, 50.176514623],
        [8.709147258, 50.176568126],
        [8.709092472, 50.176740179],
        [8.709067827, 50.17681761],
        [8.709064029, 50.176829542],
        [8.709044351, 50.176830699],
        [8.709027199, 50.176831707],
        [8.709025911, 50.176840979],
        [8.709010331, 50.176953251],
        [8.709004524, 50.176995092],
        [8.708998374, 50.177039407],
        [8.708998548, 50.177068616],
        [8.708998749, 50.177102891],
        [8.708999077, 50.177159068],
        [8.708999619, 50.177247545],
        [8.708999634, 50.17724979],
        [8.709027189, 50.177313599],
        [8.709154464, 50.177608347],
        [8.709159628, 50.177620307],
        [8.709260587, 50.177783672],
        [8.709300732, 50.177848633],
        [8.708964597, 50.177948884],
        [8.708838496, 50.177986493],
        [8.708839918, 50.177988108],
        [8.709258047, 50.178463349],
        [8.709237408, 50.178496291],
        [8.709191325, 50.178569535],
        [8.709028889, 50.178827679],
        [8.709012198, 50.178855597],
        [8.709007535, 50.178862867],
        [8.709004481, 50.178867795],
        [8.708971045, 50.178921662],
        [8.708963023, 50.178922055],
        [8.708925671, 50.178923886],
        [8.708727668, 50.17893355],
        [8.708200267, 50.178983572],
        [8.708026567, 50.179000037],
        [8.708023256, 50.179000523],
        [8.707308541, 50.179105218],
        [8.706961514, 50.179138323],
        [8.706113183, 50.179219249],
        [8.705823646, 50.179310837],
        [8.70574539, 50.17933407],
        [8.705335107, 50.179455872],
        [8.704562267, 50.179684602],
        [8.704241943, 50.179774112],
        [8.703775067, 50.179904569],
        [8.703405587, 50.180017813],
        [8.703287227, 50.180049876],
        [8.703159751, 50.180095079],
        [8.7028117, 50.180218496],
        [8.702725119, 50.180258855],
        [8.702523032, 50.180353056],
        [8.702516688, 50.180356013],
        [8.702476506, 50.18036796],
        [8.702243394, 50.180437271],
        [8.702235461, 50.18043963],
        [8.701988791, 50.180480031],
        [8.702051689, 50.180586725],
        [8.702063051, 50.180605903],
        [8.702066861, 50.180612351],
        [8.70208925, 50.180650293],
        [8.703156008, 50.182459285],
        [8.703156029, 50.18245932],
        [8.703235639, 50.182594316],
        [8.703260441, 50.182636354],
        [8.704477965, 50.184701231],
        [8.704487916, 50.184718077],
        [8.704654543, 50.184659876],
        [8.706704904, 50.183943632],
        [8.707043351, 50.18388822],
        [8.707449078, 50.183821791],
        [8.707564215, 50.18380295],
        [8.707591363, 50.183798504],
        [8.707597572, 50.183807012],
        [8.707602235, 50.183813402],
        [8.707928626, 50.184260982],
        [8.708572194, 50.185143491],
        [8.708596439, 50.185176725],
        [8.709578292, 50.186520114],
        [8.711014947, 50.188485621],
        [8.711027641, 50.188502852],
        [8.707128937, 50.19077988],
        [8.705470445, 50.191749361],
        [8.705451459, 50.191760442],
        [8.705487879, 50.191775889],
        [8.70620729, 50.192081028],
        [8.707338781, 50.192560917],
        [8.708204566, 50.1929281],
        [8.709160502, 50.193333506],
        [8.710393056, 50.193855911],
        [8.711485425, 50.194318881],
        [8.712759794, 50.194859933],
        [8.712795694, 50.194875125],
        [8.712796998, 50.194873353],
        [8.712846101, 50.194806654],
        [8.712926477, 50.194761096],
        [8.713136995, 50.194641773],
        [8.713505161, 50.194575891],
        [8.713707512, 50.194554992],
        [8.713707669, 50.194554935],
        [8.714022598, 50.19444231],
        [8.714076193, 50.194423373],
        [8.71408282, 50.194426908],
        [8.715702445, 50.19529109],
        [8.715740277, 50.19531132],
        [8.715850669, 50.19528426],
        [8.715992993, 50.195249391],
        [8.71604128, 50.195237561],
        [8.716042863, 50.195238302],
        [8.716063237, 50.195247837],
        [8.716288749, 50.195343684],
        [8.716564997, 50.195461247],
        [8.717075465, 50.19567804],
        [8.71771146, 50.195948137],
        [8.717752617, 50.195965606],
        [8.718106956, 50.196060637],
        [8.718321892, 50.196118253],
        [8.718487936, 50.196162762],
        [8.71853359, 50.196175009],
        [8.71888081, 50.196423959],
        [8.718929403, 50.196458786],
        [8.71901686, 50.196521503],
        [8.719050554, 50.196545665],
        [8.719044706, 50.196618479],
        [8.71903898, 50.196690386],
        [8.719049064, 50.196716565],
        [8.719300936, 50.197371608],
        [8.719300952, 50.197371646],
        [8.719690306, 50.198384205],
        [8.719918494, 50.198977608],
        [8.720197788, 50.199079874],
        [8.721252323, 50.199465992],
        [8.721289461, 50.199479575],
        [8.721736088, 50.199642862],
        [8.723697081, 50.200359791],
        [8.723733728, 50.200373192],
        [8.726157427, 50.201259193],
        [8.726257673, 50.201295832],
        [8.728988294, 50.202293773],
        [8.728981978, 50.202302152],
        [8.728977752, 50.202307756],
        [8.729617023, 50.202588],
        [8.729255338, 50.203007442],
        [8.729284478, 50.203019035],
        [8.729638949, 50.203160096],
        [8.72966966, 50.203172314],
        [8.730694671, 50.203580182],
        [8.730691819, 50.203601582],
        [8.730593481, 50.204338683],
        [8.73056558, 50.204547793],
        [8.730472941, 50.205242176],
        [8.730426911, 50.205256905],
        [8.730467292, 50.205310328],
        [8.730559674, 50.205340012],
        [8.730648578, 50.205345162],
        [8.730925465, 50.205427431],
        [8.731009111, 50.205518788],
        [8.731458381, 50.206009411],
        [8.731742351, 50.206319514],
        [8.731606143, 50.206536333],
        [8.731367773, 50.206915762],
        [8.731106685, 50.207331368],
        [8.731084096, 50.207367311],
        [8.731491859, 50.207447545],
        [8.731379119, 50.207958648],
        [8.73124674, 50.208558669],
        [8.731185839, 50.20883166],
        [8.731079187, 50.209309618],
        [8.731005571, 50.209639269],
        [8.730909008, 50.210073408],
        [8.730750688, 50.210785322],
        [8.730705333, 50.210804098],
        [8.730786364, 50.21081813],
        [8.73079066, 50.210817891],
        [8.730885582, 50.210812606],
        [8.732835351, 50.21104346],
        [8.732915248, 50.211052921],
        [8.733459123, 50.211122636],
        [8.734908412, 50.211308401],
        [8.734976135, 50.211272415],
        [8.734976798, 50.211339157],
        [8.734977035, 50.211362948],
        [8.734978205, 50.211455406],
        [8.734980439, 50.21163185],
        [8.734945712, 50.211628895],
        [8.734527152, 50.212703983],
        [8.734307524, 50.21327211],
        [8.734266262, 50.213378738],
        [8.734222982, 50.213490683],
        [8.734007597, 50.214047726],
        [8.734418628, 50.214505363],
        [8.734513195, 50.214690732],
        [8.734646903, 50.214952794],
        [8.734717021, 50.215090234],
        [8.734863258, 50.215473638],
        [8.734949334, 50.215514919],
        [8.734953498, 50.215559816],
        [8.734618224, 50.215572601],
        [8.732137469, 50.215851728],
        [8.732115657, 50.215868669],
        [8.732069782, 50.215904524],
        [8.732070207, 50.215926101],
        [8.732075224, 50.216184302],
        [8.731981746, 50.216612108],
        [8.7318895, 50.216819838],
        [8.731795847, 50.217030891],
        [8.731595692, 50.21719468],
        [8.731387043, 50.217571515],
        [8.7313261, 50.217642847],
        [8.731171849, 50.217690497],
        [8.730598078, 50.217866898],
        [8.730516532, 50.217891792],
        [8.729516632, 50.218199004],
        [8.728853301, 50.218402806],
        [8.728540186, 50.218519038],
        [8.727539208, 50.218890511],
        [8.727207567, 50.219013618],
        [8.726904418, 50.219125653],
        [8.726835615, 50.219151023],
        [8.724340335, 50.219754413],
        [8.723621622, 50.22114942],
        [8.723577833, 50.221234543],
        [8.722295175, 50.221328763],
        [8.722117705, 50.221341645],
        [8.721968859, 50.22153641],
        [8.721805111, 50.22175067],
        [8.721766474, 50.221783409],
        [8.721585604, 50.221936664],
        [8.721566846, 50.221952558],
        [8.72154436, 50.221942434],
        [8.721508428, 50.221926257],
        [8.721292191, 50.222074895],
        [8.720934646, 50.222332505],
        [8.720731309, 50.222478917],
        [8.720116974, 50.223396414],
        [8.719555618, 50.224475678],
        [8.719517977, 50.22461017],
        [8.719385008, 50.224860593],
        [8.719226789, 50.225158586],
        [8.718644747, 50.224980893],
        [8.716408522, 50.224298142],
        [8.716398783, 50.224309984],
        [8.716360176, 50.224298204],
        [8.715611978, 50.225694436],
        [8.715492432, 50.225809082],
        [8.715482621, 50.225818705],
        [8.715478844, 50.225822409],
        [8.712919337, 50.225115766],
        [8.7129179, 50.225115305],
        [8.71280651, 50.225079519],
        [8.712795293, 50.225075877],
        [8.7127689, 50.225067299],
        [8.712589434, 50.225966207],
        [8.712360717, 50.227111747],
        [8.712305246, 50.227112302],
        [8.709381827, 50.227141406],
        [8.709282362, 50.22714257],
        [8.709290654, 50.227129396],
        [8.709338116, 50.227053985],
        [8.709654152, 50.225996426],
        [8.709679962, 50.225936769],
        [8.710001394, 50.224348625],
        [8.710238829, 50.22319411],
        [8.710319953, 50.222799636],
        [8.710355588, 50.222798652],
        [8.711137229, 50.222224145],
        [8.711148567, 50.222215812],
        [8.709980389, 50.221628054],
        [8.709729841, 50.221501989],
        [8.709600288, 50.22143219],
        [8.709545117, 50.221402466],
        [8.709512674, 50.221384737],
        [8.708538424, 50.220859309],
        [8.707586488, 50.220336399],
        [8.706163739, 50.219576777],
        [8.705811566, 50.219388741],
        [8.705669983, 50.219313146],
        [8.705552055, 50.219250195],
        [8.705567532, 50.219237531],
        [8.70571328, 50.219119239],
        [8.705771478, 50.219071934],
        [8.705774256, 50.219069677],
        [8.705444636, 50.218907394],
        [8.704665554, 50.218523818],
        [8.703964068, 50.2181788],
        [8.703930977, 50.218162535],
        [8.701754913, 50.217090485],
        [8.70174974, 50.217087937],
        [8.701667529, 50.217127543],
        [8.701395681, 50.217258506],
        [8.700601358, 50.217958734],
        [8.700594693, 50.217955111],
        [8.70058107, 50.217947705],
        [8.699440536, 50.21733471],
        [8.699226528, 50.217219565],
        [8.699091381, 50.217146849],
        [8.698862289, 50.217023685],
        [8.698626264, 50.216898285],
        [8.698608541, 50.216888868],
        [8.698364308, 50.217074774],
        [8.698356916, 50.2170804],
        [8.697692524, 50.216896122],
        [8.697650145, 50.216884279],
        [8.697526293, 50.216849949],
        [8.69725206, 50.216773934],
        [8.695171258, 50.216196767],
        [8.695143165, 50.216210552],
        [8.694844833, 50.216356939],
        [8.694786705, 50.216385461],
        [8.694615131, 50.216476869],
        [8.69409991, 50.216751356],
        [8.694084313, 50.216738819],
        [8.693056436, 50.215911994],
        [8.693046163, 50.215903759],
        [8.692936422, 50.215815857],
        [8.692926786, 50.215808139],
        [8.692717885, 50.215957354],
        [8.692624158, 50.216011618],
        [8.692031592, 50.216354695],
        [8.691685998, 50.216528966],
        [8.691553812, 50.216595623],
        [8.691508351, 50.216618556],
        [8.691483037, 50.216589629],
        [8.691090491, 50.216142467],
        [8.690584358, 50.215565901],
        [8.690570826, 50.215550495],
        [8.690525386, 50.215498767],
        [8.69046811, 50.215472814],
        [8.690436533, 50.215458588],
        [8.689130934, 50.214867046],
        [8.687018226, 50.213909756],
        [8.686960954, 50.2138838],
        [8.686925891, 50.213867883],
        [8.686223869, 50.214534728],
        [8.685553844, 50.215171157],
        [8.685471961, 50.215168353],
        [8.685466341, 50.215168161],
        [8.684879508, 50.214716777],
        [8.684506979, 50.21443025],
        [8.684099663, 50.214116944],
        [8.683978095, 50.214023431],
        [8.681955513, 50.212467451],
        [8.681919468, 50.212439716],
        [8.681905138, 50.212447418],
        [8.68188235, 50.212459663],
        [8.681124725, 50.212878702],
        [8.68025473, 50.213359876],
        [8.680207202, 50.213385996],
        [8.680003642, 50.213494245],
        [8.679935864, 50.213527128],
        [8.679845784, 50.21357083],
        [8.678321566, 50.214310618],
        [8.677945015, 50.214493372],
        [8.677362411, 50.214776127],
        [8.677321241, 50.214796106],
        [8.677179548, 50.214876824],
        [8.677112524, 50.214915006],
        [8.674453134, 50.216163705],
        [8.673028269, 50.216887259],
        [8.672496667, 50.217157177],
        [8.672478757, 50.217143354],
        [8.671189524, 50.216148832],
        [8.669125825, 50.216952612],
        [8.669124982, 50.216951652],
        [8.669079102, 50.216899329],
        [8.668039778, 50.215720507],
        [8.667871776, 50.21552995],
        [8.667797525, 50.215448198],
        [8.667085689, 50.214641579],
        [8.666812037, 50.214331471],
        [8.666746994, 50.214257709],
        [8.666090502, 50.213513688],
        [8.666048369, 50.213466009],
        [8.665241766, 50.21274891],
        [8.665221157, 50.2127306],
        [8.664602061, 50.212180499],
        [8.664582621, 50.212163477],
        [8.664583332, 50.212163043],
        [8.664589308, 50.212159386],
        [8.664649554, 50.212122526],
        [8.664333492, 50.211899981],
        [8.664272206, 50.211855846],
        [8.66424266, 50.211833735],
        [8.6642251, 50.211820649],
        [8.664017895, 50.211663442],
        [8.663797753, 50.211728614],
        [8.663707492, 50.211654571],
        [8.663685484, 50.211636509],
        [8.663385825, 50.211394346],
        [8.662688721, 50.210828818],
        [8.662567535, 50.210730502],
        [8.662547222, 50.210715703],
        [8.662479243, 50.210660927],
        [8.662044217, 50.210308976],
        [8.661968164, 50.210246993],
        [8.661170001, 50.20960005],
        [8.661117503, 50.209557499],
        [8.661019039, 50.209477738],
        [8.660936444, 50.209410252],
        [8.66030602, 50.208895441],
        [8.660245047, 50.208845649],
        [8.660210331, 50.208822172],
        [8.660175131, 50.208788086],
        [8.659946388, 50.208607885],
        [8.659922857, 50.208587498],
        [8.65960099, 50.208308337],
        [8.659594836, 50.208302999],
        [8.659535834, 50.208385445],
        [8.659447705, 50.208488036],
        [8.659312509, 50.208610266],
        [8.659034062, 50.208861895],
        [8.658939185, 50.208947569],
        [8.658923115, 50.20896208],
        [8.658880111, 50.209000881],
        [8.65881273, 50.209061817],
        [8.658757038, 50.209112088],
        [8.658744067, 50.209123828],
        [8.658700075, 50.209163615],
        [8.658273288, 50.209556044],
        [8.658264932, 50.209549006],
        [8.658128909, 50.209434504],
        [8.658119816, 50.209426853],
        [8.658088535, 50.209393497],
        [8.657860226, 50.209151089],
        [8.657812117, 50.209098536],
        [8.657216626, 50.208560716],
        [8.657182247, 50.208529689],
        [8.657148007, 50.208498662],
        [8.657039178, 50.208401058],
        [8.656681113, 50.208153298],
        [8.656012262, 50.207690481],
        [8.655491437, 50.207268246],
        [8.655062707, 50.207015219],
        [8.654246618, 50.206533572],
        [8.654205809, 50.206508889],
        [8.654140301, 50.206513657],
        [8.65406741, 50.206518557],
        [8.654006669, 50.206522646],
        [8.653772623, 50.20653842],
        [8.653277211, 50.2065718],
        [8.653182454, 50.206578314],
        [8.653182394, 50.206578319],
        [8.652784844, 50.206605649],
        [8.652273925, 50.206678918],
        [8.652210791, 50.206687971],
        [8.650816309, 50.206888952],
        [8.650752828, 50.206896901],
        [8.650670658, 50.206836237],
        [8.650414154, 50.206646439],
        [8.649804704, 50.206196258],
        [8.64971618, 50.206130894],
        [8.648733345, 50.205405166],
        [8.648733279, 50.205405117],
        [8.647658963, 50.204611805],
        [8.647557074, 50.204536624],
        [8.647518099, 50.204507884],
        [8.645806101, 50.203244753],
        [8.645719182, 50.203181465],
        [8.645717844, 50.203180491],
        [8.645656863, 50.203158532],
        [8.645175519, 50.202990125],
        [8.645175361, 50.202990069],
        [8.644365979, 50.202706883],
        [8.644286765, 50.20267913],
        [8.644261339, 50.202670242],
        [8.644225294, 50.202657636],
        [8.644203641, 50.202650192],
        [8.644069663, 50.202603219],
        [8.644044655, 50.202594422],
        [8.643360764, 50.202354348],
        [8.643974225, 50.202087526],
        [8.643974324, 50.202087498],
        [8.643983892, 50.202084737],
        [8.644342845, 50.201981177],
        [8.644912693, 50.201534584],
        [8.645211721, 50.20122068],
        [8.645588829, 50.200932803],
        [8.645323787, 50.200789701],
        [8.645144223, 50.200692749],
        [8.644590745, 50.200395897],
        [8.644491478, 50.200342656],
        [8.644381194, 50.200368571],
        [8.64324391, 50.200644692],
        [8.642546137, 50.200814071],
        [8.642465306, 50.200833686],
        [8.642440889, 50.200839815],
        [8.642077758, 50.200927792],
        [8.641822941, 50.200989626],
        [8.641794739, 50.200996505],
        [8.64168463, 50.201023182],
        [8.640865659, 50.201222042],
        [8.64055085, 50.201298525],
        [8.640508472, 50.201308822],
        [8.640427242, 50.20132853],
        [8.640330979, 50.201351877],
        [8.640257895, 50.201370653],
        [8.640234165, 50.20137675],
        [8.640074476, 50.201415183],
        [8.639628741, 50.201522456],
        [8.639215178, 50.201622913],
        [8.638816754, 50.201719696],
        [8.638744875, 50.201737859],
        [8.638737326, 50.201739767],
        [8.638704915, 50.201691398],
        [8.638685387, 50.201662209],
        [8.637938881, 50.200548952],
        [8.63790976, 50.200506291],
        [8.63786003, 50.200431547],
        [8.636980788, 50.199122252],
        [8.63695475, 50.199083583],
        [8.636903051, 50.199006387],
        [8.636677774, 50.198670941],
        [8.635881248, 50.197484327],
        [8.635846899, 50.197433694],
        [8.635742117, 50.19734635],
        [8.635004179, 50.196733189],
        [8.634844542, 50.196601403],
        [8.634459803, 50.196280819],
        [8.633876997, 50.19579668],
        [8.633818129, 50.195749474],
        [8.633128027, 50.195176712],
        [8.633108045, 50.19512421],
        [8.633089455, 50.195075366],
        [8.633072838, 50.195031705],
        [8.633491004, 50.194666951],
        [8.633517973, 50.194643426],
        [8.633550361, 50.194615174],
        [8.633601563, 50.194585398],
        [8.633675415, 50.194542478],
        [8.633573144, 50.19451078],
        [8.633159655, 50.194209483],
        [8.632680266, 50.193994361],
        [8.632198014, 50.193735855],
        [8.631945387, 50.193600436],
        [8.631759548, 50.193478273],
        [8.631486403, 50.193298717],
        [8.631062511, 50.1930712],
        [8.631059782, 50.193069735],
        [8.631032656, 50.193049712],
        [8.630653449, 50.192769798],
        [8.630010618, 50.192447885],
        [8.629741837, 50.192313313],
        [8.629731061, 50.192307917],
        [8.629376036, 50.192103336],
        [8.629211721, 50.192008648],
        [8.629207407, 50.192006163],
        [8.62917731, 50.191932619],
        [8.629063715, 50.191861309],
        [8.629063592, 50.191861232],
        [8.628956889, 50.191857931],
        [8.628956766, 50.191857927],
        [8.628946295, 50.191851436],
        [8.628259091, 50.191425515],
        [8.627584276, 50.191006841],
        [8.627544406, 50.190983611],
        [8.626638443, 50.190455937],
        [8.626530828, 50.190393256],
        [8.626423626, 50.190330816],
        [8.626283445, 50.190249177],
        [8.626092554, 50.190137995],
        [8.62574113, 50.189933312],
        [8.625690945, 50.189904022],
        [8.625254466, 50.189643075],
        [8.624945263, 50.189458217],
        [8.623777584, 50.188958559],
        [8.623768217, 50.18895455],
        [8.62373156, 50.188932767],
        [8.62365978, 50.188890101],
        [8.623624936, 50.18886931],
        [8.623451796, 50.188760207],
        [8.623123596, 50.18855339],
        [8.622942871, 50.188426847],
        [8.62294284, 50.188426825],
        [8.622934477, 50.188420969],
        [8.622681151, 50.188243672],
        [8.62248445, 50.188099267],
        [8.622249008, 50.187926417],
        [8.621932326, 50.187669653],
        [8.621567939, 50.187374207],
        [8.62087435, 50.186794321],
        [8.62012136, 50.186130265],
        [8.619968465, 50.185987941],
        [8.619924806, 50.185947302],
        [8.619692724, 50.185731619],
        [8.619596931, 50.185642595],
        [8.619093279, 50.185144039],
        [8.618819374, 50.184855395],
        [8.618617273, 50.184642416],
        [8.618605071, 50.18464038],
        [8.618526719, 50.184627311],
        [8.618464772, 50.184617129],
        [8.61813938, 50.184563739],
        [8.618131907, 50.184562028],
        [8.617658197, 50.184453566],
        [8.617429929, 50.184387251],
        [8.617318618, 50.184354913],
        [8.617196448, 50.184311987],
        [8.617012297, 50.184247382],
        [8.616961756, 50.184229592],
        [8.616958726, 50.184228181],
        [8.616867062, 50.184185465],
        [8.616342053, 50.183940807],
        [8.616318863, 50.183930007],
        [8.616294315, 50.183918598],
        [8.616130468, 50.183836344],
        [8.615821578, 50.183681389],
        [8.615304841, 50.183422162],
        [8.615193829, 50.183367493],
        [8.614790146, 50.183167032],
        [8.614482601, 50.183023447],
        [8.614277958, 50.182948511],
        [8.61427337, 50.182947469],
        [8.614135246, 50.182916094],
        [8.613959486, 50.182876169],
        [8.61392606, 50.182871475],
        [8.613550707, 50.182819003],
        [8.613373245, 50.18279414],
        [8.613180252, 50.182767165],
        [8.612543424, 50.182678085],
        [8.611488514, 50.182530515],
        [8.611244753, 50.182496445],
        [8.611183917, 50.182487971],
        [8.610167074, 50.182345965],
        [8.610060643, 50.182323046],
        [8.61000257, 50.18231054],
        [8.609728826, 50.182226023],
        [8.60919463, 50.182061614],
        [8.607412399, 50.181513134],
        [8.607357363, 50.181496055],
        [8.606911233, 50.181357416],
        [8.606821382, 50.1813295],
        [8.605799115, 50.181011884],
        [8.605747012, 50.180995714],
        [8.605627863, 50.180958639],
        [8.605560947, 50.180890373],
        [8.605506906, 50.180835242],
        [8.605425516, 50.180797971],
        [8.605389436, 50.180781451],
        [8.605341036, 50.180759269],
        [8.605266983, 50.180703908],
        [8.605326076, 50.18070428],
        [8.605372236, 50.180693827],
        [8.605406962, 50.180676415],
        [8.605437152, 50.180648457],
        [8.605459804, 50.180617878],
        [8.605476774, 50.180580267],
        [8.605527681, 50.1804507],
        [8.605537079, 50.180411823],
        [8.60556232, 50.180307415],
        [8.605577533, 50.180245164],
        [8.605593759, 50.180212855],
        [8.605619379, 50.180161787],
        [8.605644998, 50.18011098],
        [8.605668211, 50.180064848],
        [8.605787368, 50.179828082],
        [8.605819677, 50.179763641],
        [8.605911195, 50.179635978],
        [8.605914568, 50.179631185],
        [8.606136873, 50.179321199],
        [8.606166047, 50.179280474],
        [8.606204016, 50.17922756],
        [8.606278014, 50.179151385],
        [8.606335647, 50.179105357],
        [8.606355664, 50.179089372],
        [8.606375795, 50.179070093],
        [8.606554684, 50.178898778],
        [8.606647004, 50.178824732],
        [8.606737563, 50.178758951],
        [8.606826868, 50.178694073],
        [8.606837391, 50.178687433],
        [8.606901819, 50.178646778],
        [8.607091561, 50.178527021],
        [8.607257624, 50.178410871],
        [8.607293544, 50.17838573],
        [8.607427267, 50.178297258],
        [8.607546854, 50.178209908],
        [8.607629371, 50.178146594],
        [8.607646979, 50.178133082],
        [8.607682536, 50.1781058],
        [8.607740702, 50.178066916],
        [8.607981511, 50.177905913],
        [8.608000696, 50.177893076],
        [8.608109086, 50.177820612],
        [8.608150157, 50.177796159],
        [8.608360763, 50.177670774],
        [8.608811034, 50.177385594],
        [8.608943099, 50.177301948],
        [8.609321096, 50.177044461],
        [8.609565934, 50.176834527],
        [8.609581059, 50.176821558],
        [8.609732242, 50.176630878],
        [8.610030307, 50.176254936],
        [8.610031146, 50.176253877],
        [8.609965276, 50.176228663],
        [8.609788663, 50.17625604],
        [8.609713075, 50.176267907],
        [8.609710168, 50.176268363],
        [8.609480098, 50.176121319],
        [8.60924778, 50.175972092],
        [8.609244237, 50.175969814],
        [8.60923249, 50.17596226],
        [8.609191727, 50.175941786],
        [8.608911852, 50.17580121],
        [8.608840581, 50.17576544],
        [8.608825132, 50.175757705],
        [8.608766842, 50.175728476],
        [8.608418673, 50.175541296],
        [8.608411581, 50.175537489],
        [8.608390385, 50.17552609],
        [8.608369752, 50.175514971],
        [8.607699712, 50.175122325],
        [8.607321094, 50.174900449],
        [8.607307981, 50.174894921],
        [8.607266699, 50.174877369],
        [8.606614352, 50.174599999],
        [8.606342061, 50.174483472],
        [8.606152936, 50.174402534],
        [8.606146229, 50.174400147],
        [8.606134724, 50.174396051],
        [8.606072773, 50.174369716],
        [8.606023572, 50.1743488],
        [8.605963391, 50.174323198],
        [8.604782448, 50.173821035],
        [8.604684578, 50.173779445],
        [8.603558988, 50.172729376],
        [8.602377313, 50.171623784],
        [8.602358334, 50.171600165],
        [8.602353481, 50.171594127],
        [8.602213016, 50.171636161],
        [8.602050938, 50.171684693],
        [8.601891964, 50.171732327],
        [8.601691717, 50.171792226],
        [8.601607099, 50.171817559],
        [8.601385957, 50.17188386],
        [8.60128492, 50.171914082],
        [8.601161572, 50.171951059],
        [8.601037519, 50.171988112],
        [8.600856371, 50.172042422],
        [8.600675204, 50.17209663],
        [8.60050358, 50.172148005],
        [8.600424168, 50.172171828],
        [8.60024932, 50.172224168],
        [8.600125266, 50.172261321],
        [8.600042614, 50.17228603],
        [8.599940874, 50.172316517],
        [8.599735582, 50.172377935],
        [8.599614759, 50.17241411],
        [8.599443133, 50.172465561],
        [8.599315993, 50.172503601],
        [8.599188851, 50.172541642],
        [8.599052181, 50.172582618],
        [8.598855154, 50.172641632],
        [8.598715242, 50.172683493],
        [8.598575331, 50.172725355],
        [8.597975278, 50.172905058],
        [8.597606493, 50.173015442],
        [8.597517525, 50.173042105],
        [8.597479347, 50.173053534],
        [8.597409464, 50.173074454],
        [8.597294952, 50.173108671],
        [8.59718058, 50.173142975],
        [8.597090314, 50.173169605],
        [8.596973045, 50.173204201],
        [8.596935289, 50.173215858],
        [8.596873119, 50.173235052],
        [8.596111808, 50.172074377],
        [8.59608033, 50.172028983],
        [8.595319535, 50.170866453],
        [8.595291654, 50.170836239],
        [8.594290565, 50.169748221],
        [8.594258172, 50.169715455],
        [8.593303918, 50.168680617],
        [8.593267766, 50.168635719],
        [8.593239335, 50.168604772],
        [8.592085414, 50.167350134],
        [8.592060475, 50.167321162],
        [8.592058246, 50.167318573],
        [8.591909647, 50.167363084],
        [8.591760774, 50.167407693],
        [8.591653289, 50.167439948],
        [8.591542711, 50.167473094],
        [8.591390743, 50.167518592],
        [8.591238909, 50.167564078],
        [8.591068976, 50.167614995],
        [8.590923742, 50.167658538],
        [8.590851332, 50.167680217],
        [8.590778796, 50.167701988],
        [8.590688288, 50.16772909],
        [8.590597907, 50.167756176],
        [8.59050741, 50.167783288],
        [8.590421669, 50.167808965],
        [8.590336491, 50.16783447],
        [8.590266468, 50.167855527],
        [8.590177701, 50.167882078],
        [8.590096537, 50.167906345],
        [8.589995918, 50.167936558],
        [8.589895728, 50.167966591],
        [8.589794272, 50.167996979],
        [8.589632475, 50.168045398],
        [8.58946941, 50.168094269],
        [8.589390943, 50.168117788],
        [8.589236736, 50.168164002],
        [8.589154923, 50.168188525],
        [8.589073671, 50.168212872],
        [8.588296777, 50.168445779],
        [8.588294076, 50.168446588],
        [8.587941673, 50.168197569],
        [8.588100112, 50.167470952],
        [8.588111575, 50.167374707],
        [8.588124299, 50.167268632],
        [8.588146552, 50.167082963],
        [8.588156618, 50.166999018],
        [8.588176974, 50.166829311],
        [8.588182944, 50.166779454],
        [8.588187074, 50.166745018],
        [8.588414336, 50.165575954],
        [8.588419147, 50.165553945],
        [8.588443096, 50.165440988],
        [8.588472452, 50.165303272],
        [8.588501137, 50.165168663],
        [8.58853036, 50.165031475],
        [8.588629276, 50.164567092],
        [8.588665717, 50.164396118],
        [8.588678535, 50.164335929],
        [8.58869672, 50.164261778],
        [8.588746767, 50.164057876],
        [8.588793825, 50.163866325],
        [8.588804765, 50.163817726],
        [8.588812703, 50.163789436],
        [8.58881201, 50.163788894],
        [8.588877483, 50.163381487],
        [8.588913909, 50.163154782],
        [8.589018687, 50.162551259],
        [8.589176249, 50.161646577],
        [8.589300724, 50.16057935],
        [8.58947821, 50.15992285],
        [8.589566716, 50.159640607],
        [8.589766375, 50.159208096],
        [8.589774186, 50.159209669],
        [8.589774487, 50.15920973],
        [8.589818721, 50.159218638],
        [8.589816971, 50.15922265],
        [8.589777384, 50.159313366],
        [8.589797653, 50.159391393],
        [8.590118073, 50.159651329],
        [8.590811481, 50.160213835],
        [8.590846879, 50.16021888],
        [8.590915404, 50.160228648],
        [8.590919711, 50.160227165],
        [8.59407542, 50.159140937],
        [8.59759946, 50.15792414],
        [8.597673983, 50.157898497],
        [8.597748013, 50.157873023],
        [8.597828878, 50.157858738],
        [8.59895256, 50.157660014],
        [8.599425366, 50.157576334],
        [8.599630326, 50.157540045],
        [8.599704852, 50.157527006],
        [8.600458882, 50.157395085],
        [8.600691477, 50.15735399],
        [8.602486996, 50.157036745],
        [8.602554448, 50.157024826],
        [8.602599251, 50.157016914],
        [8.60263203, 50.157011119],
        [8.602677226, 50.157003129],
        [8.602690175, 50.157000845],
        [8.602733898, 50.156993118],
        [8.602564107, 50.156605959],
        [8.602561286, 50.156599528],
        [8.602234445, 50.156180177],
        [8.602220023, 50.156161672],
        [8.602217457, 50.156158378],
        [8.602097659, 50.156093241],
        [8.602094408, 50.156091474],
        [8.602086632, 50.156072514],
        [8.60207699, 50.156049034],
        [8.602069938, 50.156031839],
        [8.602097076, 50.155999539],
        [8.602140885, 50.155947393],
        [8.602004553, 50.1556244],
        [8.601770881, 50.15507122],
        [8.601312305, 50.1543101],
        [8.601249166, 50.154205306],
        [8.601108275, 50.153940373],
        [8.600787944, 50.153338005],
        [8.600656475, 50.153107048],
        [8.60039394, 50.152645851],
        [8.600290068, 50.152463375],
        [8.600283422, 50.152265053],
        [8.60019593, 50.152086925],
        [8.600074554, 50.151993817],
        [8.60007181, 50.151988826],
        [8.599614079, 50.151156038],
        [8.599458093, 50.150873284],
        [8.59914972, 50.150314287],
        [8.598947355, 50.149947407],
        [8.598717921, 50.149531443],
        [8.598221069, 50.14863069],
        [8.597826701, 50.147933318],
        [8.597826687, 50.147933293],
        [8.597729691, 50.14776177],
        [8.597275553, 50.146940437],
        [8.596816558, 50.146096151],
        [8.596805646, 50.146079391],
        [8.596293404, 50.145292249],
        [8.595891553, 50.144620474],
        [8.595477696, 50.143928509],
        [8.595210151, 50.143481083],
        [8.595080887, 50.143263599],
        [8.594993206, 50.143209891],
        [8.594991921, 50.143206972],
        [8.594944655, 50.1430996],
        [8.594925717, 50.143059033],
        [8.594924553, 50.143056538],
        [8.59492824, 50.142964239],
        [8.594568742, 50.142340867],
        [8.594000267, 50.141255077],
        [8.593989412, 50.141234343],
        [8.593473865, 50.140250873],
        [8.593332908, 50.139784134],
        [8.59332566, 50.139781033],
        [8.593147101, 50.139704639],
        [8.593131908, 50.139698113],
        [8.592787131, 50.139550516],
        [8.592702886, 50.13951445],
        [8.592667623, 50.139499402],
        [8.592667033, 50.139499149],
        [8.592662377, 50.139497156],
        [8.592482287, 50.139420037],
        [8.591663788, 50.139069535],
        [8.590804083, 50.1387013],
        [8.590747431, 50.138682501],
        [8.590496108, 50.1385991],
        [8.59049357, 50.138598257],
        [8.590500728, 50.138565252],
        [8.590501286, 50.138562682],
        [8.588278535, 50.137735572],
        [8.587518608, 50.137452779],
        [8.587359178, 50.137390845],
        [8.585579754, 50.136699567],
        [8.585351213, 50.13661078],
        [8.585345556, 50.136608141],
        [8.585008828, 50.136451035],
        [8.584986628, 50.136440678],
        [8.584039862, 50.13599863],
        [8.584026898, 50.135991464],
        [8.583941552, 50.135944291],
        [8.583390129, 50.135638839],
        [8.582969572, 50.135405671],
        [8.582907725, 50.135377039],
        [8.580814436, 50.134407917],
        [8.580785855, 50.134394539],
        [8.57964495, 50.133860508],
        [8.579591333, 50.133835411],
        [8.579479452, 50.133783041],
        [8.579420208, 50.13375531],
        [8.57888629, 50.133533672],
        [8.57858718, 50.133409718],
        [8.578276728, 50.133280975],
        [8.576312153, 50.132465766],
        [8.576297842, 50.132459825],
        [8.576237807, 50.13243491],
        [8.576041319, 50.132353363],
        [8.573269679, 50.13118381],
        [8.57326951, 50.131183739],
        [8.573095159, 50.131110164],
        [8.572834908, 50.130999504],
        [8.572159138, 50.130712157],
        [8.571986661, 50.130638799],
        [8.569393577, 50.129542484],
        [8.569328202, 50.129515019],
        [8.568310728, 50.129086723],
        [8.567173339, 50.128600542],
        [8.565355481, 50.127839426],
        [8.565354396, 50.127841985],
        [8.565202038, 50.127777377],
        [8.564117658, 50.12731748],
        [8.56408644, 50.127345842],
        [8.564085748, 50.127346472],
        [8.56404866, 50.127330959],
        [8.564015102, 50.127316268],
        [8.564003027, 50.127310982],
        [8.56390848, 50.127272065],
        [8.560651837, 50.125931499],
        [8.560636639, 50.125925243],
        [8.56055996, 50.126006496],
        [8.56046757, 50.125966149],
        [8.555433788, 50.123806385],
        [8.555376958, 50.123781983],
        [8.554455568, 50.123405242],
        [8.55328349, 50.122925981],
        [8.553180027, 50.122883607],
        [8.553168701, 50.122878969],
        [8.55204461, 50.12241886],
        [8.551454164, 50.122177073],
        [8.550903256, 50.121951473],
        [8.549126053, 50.121364825],
        [8.548996827, 50.121322249],
        [8.54890789, 50.121292964],
        [8.546003274, 50.120122921],
        [8.545012744, 50.119780473],
        [8.542576969, 50.118930695],
        [8.542365551, 50.118856933],
        [8.539852184, 50.1179378],
        [8.537547138, 50.117094072],
        [8.537181886, 50.116960558],
        [8.536662746, 50.116770789],
        [8.535869837, 50.116496548],
        [8.53527619, 50.11629122],
        [8.534586006, 50.116050717],
        [8.534237348, 50.116047595],
        [8.533781183, 50.115782341],
        [8.533539286, 50.115684899],
        [8.533425655, 50.115639125],
        [8.533419371, 50.115636594],
        [8.533532589, 50.115509812],
        [8.533533442, 50.115508858],
        [8.533440592, 50.115472811],
        [8.53302141, 50.115317763],
        [8.532964774, 50.115298736],
        [8.532845252, 50.115432032],
        [8.532594578, 50.115813293],
        [8.532592177, 50.115816944],
        [8.532350624, 50.115837294],
        [8.531841868, 50.115880154],
        [8.531841812, 50.115880159],
        [8.531606255, 50.115900002],
        [8.531482053, 50.115910461],
        [8.531368416, 50.115919982],
        [8.531305866, 50.115925304],
        [8.530988684, 50.115952021],
        [8.530985183, 50.115956243],
        [8.530914545, 50.11604141],
        [8.530729984, 50.116263935],
        [8.530727609, 50.116266798],
        [8.529751261, 50.115795769],
        [8.529492664, 50.11567108],
        [8.529474475, 50.11566231],
        [8.529399971, 50.115671908],
        [8.529258847, 50.115765609],
        [8.529159096, 50.115831851],
        [8.52898732, 50.115945916],
        [8.528812122, 50.116062234],
        [8.528624779, 50.116186638],
        [8.528528419, 50.116250609],
        [8.528431579, 50.116314911],
        [8.528304567, 50.116399247],
        [8.528253694, 50.116439865],
        [8.528197551, 50.116484688],
        [8.528120044, 50.116546586],
        [8.528084827, 50.116574683],
        [8.528028246, 50.116619855],
        [8.527908462, 50.116715465],
        [8.527674739, 50.1169021],
        [8.527571667, 50.116984384],
        [8.52756114, 50.116992792],
        [8.527433499, 50.117106477],
        [8.52737255, 50.117160764],
        [8.52730411, 50.117221738],
        [8.527238364, 50.117280276],
        [8.527200731, 50.117313792],
        [8.527163505, 50.11734695],
        [8.527055512, 50.117443148],
        [8.526983912, 50.117506913],
        [8.526906189, 50.117576138],
        [8.526677126, 50.117801276],
        [8.526562016, 50.117914409],
        [8.526452998, 50.118021554],
        [8.526446904, 50.118027543],
        [8.526143062, 50.117915314],
        [8.525841737, 50.117804013],
        [8.525091663, 50.118546503],
        [8.525085115, 50.118552985],
        [8.524964235, 50.118495024],
        [8.524954441, 50.118490328],
        [8.524805371, 50.118627909],
        [8.524720546, 50.118706318],
        [8.524636472, 50.118784011],
        [8.523232134, 50.119974849],
        [8.523128544, 50.119922121],
        [8.523009749, 50.119861654],
        [8.52299494, 50.119854115],
        [8.522853444, 50.120013545],
        [8.522743159, 50.120137807],
        [8.522557953, 50.120346476],
        [8.522412977, 50.120509819],
        [8.522313096, 50.120622355],
        [8.52221668, 50.120730984],
        [8.522120957, 50.120838835],
        [8.522009282, 50.120964663],
        [8.521455796, 50.120672096],
        [8.520643386, 50.120155447],
        [8.520611592, 50.120137477],
        [8.520620817, 50.120159535],
        [8.520647374, 50.120223034],
        [8.520639566, 50.120222953],
        [8.520545743, 50.120221985],
        [8.520277645, 50.120382165],
        [8.520051606, 50.120517167],
        [8.519895757, 50.120610302],
        [8.519754962, 50.120694409],
        [8.519552424, 50.120815482],
        [8.518703834, 50.121322461],
        [8.518615751, 50.121374879],
        [8.518600596, 50.121383897],
        [8.518480471, 50.121302576],
        [8.518285791, 50.121170726],
        [8.518093291, 50.12104035],
        [8.513540655, 50.121919516],
        [8.513447724, 50.121803331],
        [8.513234107, 50.121536412],
        [8.512861297, 50.121070409],
        [8.512771187, 50.120957697],
        [8.512832456, 50.120936062],
        [8.512744003, 50.120916362],
        [8.512503589, 50.120550076],
        [8.512408467, 50.12040513],
        [8.512408447, 50.1204051],
        [8.512028281, 50.119825797],
        [8.511925558, 50.119669375],
        [8.511858502, 50.119567052],
        [8.511738018, 50.119383502],
        [8.512242101, 50.119324907],
        [8.512877798, 50.11925101],
        [8.512877081, 50.119247789],
        [8.512867901, 50.119206557],
        [8.512819494, 50.118988607],
        [8.512807611, 50.118933474],
        [8.512797993, 50.118888904],
        [8.512749798, 50.118670875],
        [8.512699048, 50.118441264],
        [8.512646923, 50.118205436],
        [8.512610435, 50.118040341],
        [8.512582606, 50.117914426],
        [8.512580968, 50.117908907],
        [8.512554835, 50.117820856],
        [8.512535461, 50.117788362],
        [8.512397736, 50.117521048],
        [8.512393695, 50.117513204],
        [8.512332122, 50.117559606],
        [8.512278875, 50.11759858],
        [8.511878608, 50.117648316],
        [8.511685636, 50.117609087],
        [8.511675852, 50.117607098],
        [8.511604787, 50.11751303],
        [8.511534253, 50.117421752],
        [8.51149938, 50.117322365],
        [8.511495647, 50.117311726],
        [8.511312363, 50.117294675],
        [8.510688447, 50.117431761],
        [8.510199109, 50.117335161],
        [8.509854043, 50.11726704],
        [8.509839981, 50.117246114],
        [8.509822903, 50.117220598],
        [8.509795758, 50.117180117],
        [8.509727005, 50.117077697],
        [8.509626304, 50.116927559],
        [8.509621178, 50.116919919],
        [8.509532915, 50.116894725],
        [8.509390686, 50.116854207],
        [8.508801331, 50.116623444],
        [8.508430201, 50.116554799],
        [8.508348405, 50.116539978],
        [8.508247917, 50.116521033],
        [8.508170974, 50.116530319],
        [8.507873008, 50.116566277],
        [8.507871628, 50.116564298],
        [8.507796354, 50.11645627],
        [8.507767733, 50.116415315],
        [8.507689123, 50.116303915],
        [8.507667718, 50.116272403],
        [8.507416439, 50.115912179],
        [8.50727931, 50.115715594],
        [8.507249958, 50.115673844],
        [8.507224048, 50.115637143],
        [8.507267912, 50.115589456],
        [8.507326685, 50.115525558],
        [8.507316012, 50.115515726],
        [8.507301047, 50.11550194],
        [8.506867665, 50.115109412],
        [8.506620478, 50.114885524],
        [8.50661667, 50.114882074],
        [8.5065469, 50.114819663],
        [8.506554325, 50.1148184],
        [8.506551735, 50.114810481],
        [8.506462283, 50.114734175],
        [8.505187824, 50.113654389],
        [8.505061129, 50.113547018],
        [8.504559888, 50.113122263],
        [8.504383687, 50.112972938],
        [8.504117573, 50.112747412],
        [8.503987488, 50.11263712],
        [8.503708346, 50.112400641],
        [8.50311805, 50.111900561],
        [8.503048205, 50.111841389],
        [8.502971536, 50.111776457],
        [8.502523852, 50.111397315],
        [8.501801471, 50.110784151],
        [8.501708635, 50.110705367],
        [8.501694362, 50.110693169],
        [8.501657963, 50.110664609],
        [8.501567616, 50.110593732],
        [8.49976996, 50.109230504],
        [8.499640538, 50.109129941],
        [8.499636276, 50.109126629],
        [8.49967204, 50.109129011],
        [8.499732949, 50.109133068],
        [8.499744393, 50.109126874],
        [8.502294167, 50.107746725],
        [8.502288784, 50.107708083],
        [8.502287011, 50.10769536],
        [8.501006895, 50.107219664],
        [8.500720437, 50.107113212],
        [8.500215968, 50.106925753],
        [8.500001533, 50.106846075],
        [8.499657473, 50.106718199],
        [8.499554356, 50.106724097],
        [8.499543464, 50.10672472],
        [8.498314227, 50.107390337],
        [8.497984987, 50.107568749],
        [8.497874877, 50.107617901],
        [8.497819348, 50.107642604],
        [8.497818999, 50.10764276],
        [8.497817435, 50.107643455],
        [8.49780139, 50.107628038],
        [8.497791326, 50.107618367],
        [8.497789616, 50.107616724],
        [8.497830986, 50.107598371],
        [8.497847618, 50.107590992],
        [8.497845987, 50.107590808],
        [8.497807228, 50.107586433],
        [8.497750732, 50.107580055],
        [8.497614043, 50.107449639],
        [8.496430426, 50.106320311],
        [8.49622104, 50.106122702],
        [8.496138003, 50.106044315],
        [8.496103343, 50.106011658],
        [8.496097847, 50.10600648],
        [8.494112298, 50.106624036],
        [8.494071442, 50.106652806],
        [8.493776988, 50.10686028],
        [8.493576001, 50.107001894],
        [8.493328156, 50.107175051],
        [8.493148734, 50.107293504],
        [8.492765093, 50.107543778],
        [8.492553387, 50.107681871],
        [8.492344763, 50.107818109],
        [8.491935011, 50.108085127],
        [8.491933223, 50.108080366],
        [8.491906195, 50.108008353],
        [8.491561831, 50.107088237],
        [8.491515096, 50.106961637],
        [8.491395962, 50.106709655],
        [8.491381435, 50.106683077],
        [8.491374446, 50.106685145],
        [8.490980259, 50.106801836],
        [8.490980208, 50.106801851],
        [8.490142291, 50.107049891],
        [8.489879254, 50.107112278],
        [8.488810954, 50.107378581],
        [8.48871299, 50.107371564],
        [8.488065662, 50.107325188],
        [8.487881738, 50.107392987],
        [8.487505561, 50.107531656],
        [8.485543445, 50.108196439],
        [8.482444143, 50.109517474],
        [8.482394162, 50.109538777],
        [8.482080454, 50.109235372],
        [8.482077632, 50.109232643],
        [8.482021153, 50.109258724],
        [8.481744687, 50.109384797],
        [8.479981628, 50.110188751],
        [8.479954309, 50.110201208],
        [8.479872518, 50.110345298],
        [8.479628144, 50.11073549],
        [8.479625431, 50.11073982],
        [8.479527199, 50.110671946],
        [8.479480675, 50.11063833],
        [8.479026996, 50.11030652],
        [8.479026333, 50.110305781],
        [8.479025707, 50.11030558],
        [8.47897956, 50.110271884],
        [8.478969768, 50.110264729],
        [8.478631949, 50.110018555],
        [8.478621054, 50.110010616],
        [8.478554526, 50.110034871],
        [8.478151971, 50.110181473],
        [8.477810944, 50.110305667],
        [8.477803668, 50.110299696],
        [8.4770684, 50.109696278],
        [8.477038181, 50.109671446],
        [8.475877582, 50.108715953],
        [8.476081399, 50.108581729],
        [8.476230879, 50.108490701],
        [8.476437033, 50.108365162],
        [8.476599207, 50.108266396],
        [8.476601881, 50.108264682],
        [8.476751993, 50.108168289],
        [8.477055959, 50.107973073],
        [8.477700372, 50.10755924],
        [8.478042086, 50.107339782],
        [8.478285185, 50.107183668],
        [8.478455546, 50.107074256],
        [8.47859378, 50.106981861],
        [8.478756136, 50.106873339],
        [8.478774812, 50.106860306],
        [8.479097693, 50.106635006],
        [8.479366174, 50.106447681],
        [8.479729648, 50.106194052],
        [8.479757209, 50.10617482],
        [8.479967667, 50.106027969],
        [8.480149674, 50.105900967],
        [8.480188679, 50.105870898],
        [8.480263234, 50.105813425],
        [8.480532172, 50.105606103],
        [8.480943646, 50.105288891],
        [8.48095532, 50.105278405],
        [8.480948449, 50.10527382],
        [8.479288271, 50.104165985],
        [8.479112417, 50.104049239],
        [8.479078415, 50.104026665],
        [8.477300092, 50.102845947],
        [8.477317929, 50.102838802],
        [8.477417795, 50.102798801],
        [8.477506281, 50.102763362],
        [8.477562465, 50.10274086],
        [8.477531229, 50.102716032],
        [8.477522415, 50.102709034],
        [8.475557253, 50.101147038],
        [8.474636032, 50.101352174],
        [8.474358308, 50.101337379],
        [8.474321156, 50.101297833],
        [8.473702904, 50.100647071],
        [8.473663439, 50.100664343],
        [8.473636219, 50.10063812],
        [8.473634199, 50.100636169],
        [8.472943338, 50.099992712],
        [8.47276052, 50.099822435]
      ]
    ]
  }
}
